const default_pregnancy_milestone_value_en = [
  {
    id: 1,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "In the 1st week of pregnancy, you will have vaginal bleeding as your body sheds the lining of the uterus that shed the unfertilized egg last month.",
            value: false,
          },
          {
            text: "You will experience the typical symptoms you normally feel when starting your period, including bloating and mood changes from fluctuating hormones.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume more fresh fruit, vegetables and 3-4 liters of water every day.",
            value: false,
          },
          {
            text: "You should start taking 400 micrograms of folic acid every day.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Write the date of your last two menstrual periods.",
            value: false,
          },
          {
            text: "Get a preconception checkup to learn more about the side effects of any medication you take, review your medical and vaccination history, and screen you for sexually transmitted infections.",
            value: false,
          },
          {
            text: "Visit the dentist to have your dental health checked and avoid complications during pregnancy.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Get enough sleep.",
            value: false,
          },
          {
            text: "Record the first day of your period as you will need it to calculate your baby`s gestational age.",
            value: false,
          },
          {
            text: "Time for a healthy, stress-free lifestyle for you and your partner.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You will ovulate this week. Your cervical mucus increases and is thinner, sticky, and slippery at the time of ovulation. The mucus looks like a clear white gel.",
            value: false,
          },
          {
            text: "If you are tracking your basal body temperature, you will notice it rising. It is lowest before ovulation, then rises by about half a degree as soon as ovulation occurs.",
            value: false,
          },
          {
            text: "You may experience other ovulation symptoms such as light spotting, lower abdominal cramps and increased sex drive.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume more fresh fruits and vegetables every day. Include lean meat and fish in your diet.",
            value: false,
          },
          {
            text: "Take a good prenatal supplement recommended by your obstetrician - it should contain folic acid.",
            value: false,
          },
          {
            text: "Drink at least 10 glasses of water every day.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol; reduce your caffeine intake.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Visit your dentist if you haven`t already.",
            value: false,
          },
          {
            text: "Talk to your doctor about any medication you`re taking, whether prescription or over-the-counter, and check that it`s safe to continue with it.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Maintain a stress-free lifestyle with at least 8 hours of sleep and regular exercise daily.",
            value: false,
          },
          {
            text: "Track your menstrual cycle and look for signs of ovulation.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 3,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may notice some implantation bleeding or spotting that lasts 1-2 days.",
            value: false,
          },
          {
            text: "Your sense of smell may increase.",
            value: false,
          },
          {
            text: "Your basal body temperature may always be high and you may feel unusually tired.",
            value: false,
          },
          {
            text: "Your home pregnancy test may or may not show a positive result yet because it may be too early for pregnancy to be reflected.",
            value: false,
          },
          {
            text: "You may experience nausea, bloating or an urgent need to urinate.",
            value: false,
          },
          {
            text: "Your breasts may be more sensitive than normal.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruit, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Avoid consuming raw foods.",
            value: false,
          },
          {
            text: "Start a daily intake of a folic acid prenatal supplement.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Consume less caffeine.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Visit the dentist to have your dental health checked.",
            value: false,
          },
          {
            text: "Purchase a home pregnancy test kit.",
            value: false,
          },
          {
            text: "Find a good obstetrician.",
            value: false,
          },
          {
            text: "Tell your doctor about any medication you are using, whether prescription or over-the-counter, and check that it is safe to continue with it.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Minimize the stress in your life.",
            value: false,
          },
          {
            text: "Sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Exercise regularly.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 4,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may notice some implantation bleeding or spotting that last 1-2 days.",
            value: false,
          },
          {
            text: "Your sense of smell may increase.",
            value: false,
          },
          {
            text: "Your basal body temperature may always be high and you may feel unusually tired.",
            value: false,
          },
          {
            text: "Your home pregnancy test may or may not show a positive result yet, because it may be early to reflect pregnancy.",
            value: false,
          },
          {
            text: "You may experience nausea, bloating or an urgent need to urinate.",
            value: false,
          },
          {
            text: "Your breasts may be more sensitive than normal.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take a good prenatal supplement containing folic acid every day.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Consume less or no caffeine.",
            value: false,
          },
          {
            text: "Avoid consuming raw foods.",
            value: false,
          },
          {
            text: "Avoid consuming foods containing preservatives.",
            value: false,
          },
          {
            text: "Reduce your sugar and salt intake.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Take a home pregnancy test to confirm your pregnancy.",
            value: false,
          },
          {
            text: "Find an obstetrician and gynecologist and make your first prenatal appointment.",
            value: false,
          },
          {
            text: "Tell your doctor about any prescription or over-the-counter medications you use and check whether they are safe to continue with.",
            value: false,
          },
          {
            text: "If you think you or your partner may have a Sexually Transmitted Infection (STI), get a checkup as early as possible.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Minimize the stress in your life.",
            value: false,
          },
          {
            text: "Sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Exercise regularly.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 5,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "Your sense of smell may increase.",
            value: false,
          },
          {
            text: "Your basal body temperature may always be high and you may feel unusually tired.",
            value: false,
          },
          {
            text: "Your home pregnancy test may or may not show a positive result yet, because it may be early to reflect pregnancy.",
            value: false,
          },
          {
            text: "You may have nausea, bloating or an urgent need to urinate.",
            value: false,
          },
          {
            text: "Your breasts may feel larger and more sensitive than normal.",
            value: false,
          },
          {
            text: "You may experience sudden mood swings, mild belly cramps and notice that your period is delayed.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take a good prenatal supplement containing folic acid every day.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Consume less caffeine.",
            value: false,
          },
          {
            text: "Avoid consuming raw foods.",
            value: false,
          },
          {
            text: "Avoid consuming foods containing preservatives.",
            value: false,
          },
          {
            text: "Reduce your sugar and salt intake.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "If your period is late, use a home pregnancy test to check if you are pregnant by using first-morning urine as a sample.",
            value: false,
          },
          {
            text: "If your pregnancy test is positive, make an appointment with an obstetrician to confirm your pregnancy.",
            value: false,
          },
          {
            text: "Visit the dentist to have your dental health checked.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "What Your Doctor Needs to Know",
        checklists: [
          {
            text: "Your menstrual calendar and the date of your last menstrual period",
            value: false,
          },
          {
            text: "Family planning tool and previously used contraceptive types",
            value: false,
          },
          {
            text: "If you have had a genital infection before",
            value: false,
          },
          {
            text: "If you have had any abnormal pap smears",
            value: false,
          },
          {
            text: "If you have had any problems, illness or surgery related to your genitals",
            value: false,
          },
          {
            text: "Information about previous abortion, miscarriage or childbirth",
            value: false,
          },
          {
            text: "If you have had an ectopic or molar pregnancy before",
            value: false,
          },
          {
            text: "If you currently have any medical conditions - major or minor",
            value: false,
          },
          {
            text: "Your family history of illness or genetic problems",
            value: false,
          },
          {
            text: "If you have had a blood transfusion before",
            value: false,
          },
          {
            text: "If you have had chickenpox or have been vaccinated against chickenpox and diphtheria",
            value: false,
          },
          {
            text: "If you are taking medication",
            value: false,
          },
          {
            text: "You and your partner`s blood types and Rh factor",
            value: false,
          },
          {
            text: "If you have had the MMR vaccine",
            value: false,
          },
          {
            text: "If you have had the HPV vaccine",
            value: false,
          },
          {
            text: "Your vaccination history",
            value: false,
          },
          {
            text: "Your mental health history: any history of depression, anxiety disorder or other mental health disorders.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Minimize the stress in your life.",
            value: false,
          },
          {
            text: "Sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Exercise regularly.",
            value: false,
          },
          {
            text: "Avoid beauty care products that contain chemicals and harmful ingredients.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 6,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "Your breasts feel sensitive and swollen.",
            value: false,
          },
          {
            text: "You may feel more tired than usual.",
            value: false,
          },
          {
            text: "You will be sensitive to odors.",
            value: false,
          },
          {
            text: "Your basal body temperature may always be high, even at rest.",
            value: false,
          },
          {
            text: "You may start to experience nausea or bloating.",
            value: false,
          },
          {
            text: "You may feel the need to urinate more often.",
            value: false,
          },
          {
            text: "You may experience mood swings.",
            value: false,
          },
          {
            text: "You may experience mild belly cramps.",
            value: false,
          },
          {
            text: "Your period is late.",
            value: false,
          },
          {
            text: "A home pregnancy test will likely show a positive result.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Avoid consuming raw foods.",
            value: false,
          },
          {
            text: "Avoid consuming foods containing preservatives.",
            value: false,
          },
          {
            text: "Reduce your sugar and salt intake.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "If your period is late, use a home pregnancy test to check if you are pregnant.",
            value: false,
          },
          {
            text: "If your pregnancy test is positive, make an appointment with an obstetrician to confirm your pregnancy.",
            value: false,
          },
          {
            text: "Visit the dentist to have your dental health checked.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "What Your Doctor Needs to Know",
        checklists: [
          {
            text: "Your menstrual calendar and the date of your last menstrual period",
            value: false,
          },
          {
            text: "Family planning tool and types of birth control pills used before",
            value: false,
          },
          {
            text: "If you have had a genital infection before",
            value: false,
          },
          {
            text: "If you have ever had an abnormal pap smear",
            value: false,
          },
          {
            text: "If you have had any problems, illness or surgery related to your genitals",
            value: false,
          },
          {
            text: "If you have received fertility treatment before",
            value: false,
          },
          {
            text: "Information about previous abortion, miscarriage or childbirth",
            value: false,
          },
          {
            text: "If you have had an ectopic or molar pregnancy before",
            value: false,
          },
          {
            text: "If you have diabetes, hypertension, epilepsy, heart problems, thyroid disorders, autoimmune disorders or any serious illness",
            value: false,
          },
          {
            text: "If you suffer from indigestion",
            value: false,
          },
          {
            text: "If you have had a blood transfusion",
            value: false,
          },
          {
            text: "If you are taking medication",
            value: false,
          },
          {
            text: "A family history of diseases such as cancer, diabetes, keloids or other genetic diseases",
            value: false,
          },
          {
            text: "If you have had chickenpox or have been vaccinated against chickenpox and diphtheria",
            value: false,
          },
          {
            text: "If you have been vaccinated against HPV",
            value: false,
          },
          {
            text: "Your vaccination history",
            value: false,
          },
          {
            text: "If you are allergic to certain drugs, substances or foods",
            value: false,
          },
          {
            text: "If you have had problems with anesthesia before",
            value: false,
          },
          {
            text: "Your mental health history: any history of depression, anxiety disorder or other mental health disorders.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Minimize the stress in your life.",
            value: false,
          },
          {
            text: "Sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Lead a healthy lifestyle.",
            value: false,
          },
          {
            text: "Exercise regularly.",
            value: false,
          },
          {
            text: "Avoid beauty care products with harmful chemicals.",
            value: false,
          },
          {
            text: "Try to relieve nausea by changing your diet (try eating small portions; ginger and crackers will also help relieve nausea).",
            value: false,
          },
          {
            text: "If you exercise regularly, talk to your obstetrician about whether you can continue.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "If you experience spotting (although it can occur early in pregnancy, spotting can also be a sign of early miscarriage or ectopic pregnancy.)",
            value: false,
          },
          {
            text: "If you have a fever higher than 38 °C",
            value: false,
          },
          {
            text: "If you experience pain or burning sensation while urinating.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 7,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "Your period is late.",
            value: false,
          },
          {
            text: "Your breasts feel tender and swollen.",
            value: false,
          },
          {
            text: "You may feel more tired than usual.",
            value: false,
          },
          {
            text: "Your sense of smell may increase.",
            value: false,
          },
          {
            text: "Your basal body temperature may always be high, even at rest.",
            value: false,
          },
          {
            text: "You may start to experience nausea or bloating.",
            value: false,
          },
          {
            text: "You may feel the need to urinate more often.",
            value: false,
          },
          {
            text: "You may experience changes in your skin (i.e. your skin may become drier or oilier).",
            value: false,
          },
          {
            text: "You may experience mood swings.",
            value: false,
          },
          {
            text: "You may experience mild belly cramps.",
            value: false,
          },
          {
            text: "You may begin to experience food cravings and/or food aversions.",
            value: false,
          },
          {
            text: "A home pregnancy test will likely show a positive result.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Avoid consuming raw foods.",
            value: false,
          },
          {
            text: "Avoid consuming foods containing preservatives.",
            value: false,
          },
          {
            text: "Reduce your sugar and salt intake.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "First prenatal checkup appointment (between the 7th and the 8th week, or earlier if you want!)",
            value: false,
          },
          {
            text: "Vitality ultrasound - to confirm that the pregnancy is progressing normally",
            value: false,
          },
          {
            text: "Blood tests (anytime in the first trimester) - to check complete blood count, blood type, hepatitis, sexually transmitted diseases (HIV, syphilis) and immunity to rubella, chickenpox",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Visit the dentist to have your dental health checked.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "What Your Doctor Needs to Know",
        checklists: [
          {
            text: "Your menstrual calendar and the date of your last menstrual period",
            value: false,
          },
          {
            text: "Family planning tool and types of birth control pills used before",
            value: false,
          },
          {
            text: "If you have had a genital infection before",
            value: false,
          },
          {
            text: "If you have had any abnormal pap smears",
            value: false,
          },
          {
            text: "If you have had any problems, illness or surgery related to the genitals",
            value: false,
          },
          {
            text: "If you have received any fertility treatment",
            value: false,
          },
          {
            text: "Information about previous abortion, miscarriage or childbirth",
            value: false,
          },
          {
            text: "If you have had an ectopic or molar pregnancy before",
            value: false,
          },
          {
            text: "If you have diabetes, hypertension, epilepsy, heart problems, thyroid disorders, autoimmune disorders or any serious illness",
            value: false,
          },
          {
            text: "If you suffer from indigestion",
            value: false,
          },
          {
            text: "If you have had a blood transfusion",
            value: false,
          },
          {
            text: "If you are taking medication",
            value: false,
          },
          {
            text: "A family history of diseases such as cancer, diabetes, keloids or other genetic diseases",
            value: false,
          },
          {
            text: "If you have had chickenpox before or have had the chickenpox vaccine",
            value: false,
          },
          {
            text: "Your vaccination history",
            value: false,
          },
          {
            text: "If you have been vaccinated against HPV",
            value: false,
          },
          {
            text: "If you are allergic to certain drugs, substances or foods",
            value: false,
          },
          {
            text: "If you have had problems with anesthesia before",
            value: false,
          },
          {
            text: "Your mental health history: any history of depression, anxiety disorder or other mental health disorders.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Minimize the stress in your life.",
            value: false,
          },
          {
            text: "Sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Lead a healthy lifestyle.",
            value: false,
          },
          {
            text: "Exercise regularly.",
            value: false,
          },
          {
            text: "Avoid beauty care products with harmful chemicals.",
            value: false,
          },
          {
            text: "Try to relieve nausea by changing your diet (try eating small portions; ginger and crackers will also help relieve nausea).",
            value: false,
          },
          {
            text: "If you exercise regularly, talk to your obstetrician about whether you can continue.",
            value: false,
          },
          {
            text: "Keep a pregnancy diary.",
            value: false,
          },
          {
            text: "Get a new bra or two to fit your growing breasts.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You experience spotting (although it can occur in the early stages of pregnancy, spotting can also be a sign of early miscarriage or ectopic pregnancy)",
            value: false,
          },
          {
            text: "You have a fever higher than 38 °C",
            value: false,
          },
          {
            text: "You experience pain or burning sensation when urinating.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 8,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may start to feel pregnancy cramps as your abdomen ligaments will be stretched due to your growing uterus.",
            value: false,
          },
          {
            text: "Your breasts will feel tender and swollen.",
            value: false,
          },
          {
            text: "You may feel more tired than usual.",
            value: false,
          },
          {
            text: "You will be sensitive to odors.",
            value: false,
          },
          {
            text: "Your basal body temperature will remain high while you are resting.",
            value: false,
          },
          {
            text: "You may start to experience nausea or bloating.",
            value: false,
          },
          {
            text: "Your need to urinate will increase.",
            value: false,
          },
          {
            text: "You may experience changes in your skin, i.e. your skin may become drier or more oily.",
            value: false,
          },
          {
            text: "You may experience mood swings.",
            value: false,
          },
          {
            text: "Varicose veins may begin to appear due to increased blood flow to your chest.",
            value: false,
          },
          {
            text: "You may start craving for certain foods.",
            value: false,
          },
          {
            text: "You may experience digestive issues such as constipation or heartburn.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Avoid consuming raw food.",
            value: false,
          },
          {
            text: "Take a pregnancy vitamin recommended by your doctor.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Avoid foods containing preservatives as much as possible.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "First prenatal care appointment (between week 7 and week 8, or earlier if you want!)",
            value: false,
          },
          {
            text: "Vitality ultrasound - to confirm that the pregnancy is progressing normally",
            value: false,
          },
          {
            text: "Blood tests (anytime in the first trimester) - to check complete blood count, blood type, hepatitis, sexually transmitted diseases (HIV, syphilis) and immunity to rubella, chickenpox",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Visit the dentist to have your dental health checked.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "What Your Doctor Needs to Know",
        checklists: [
          {
            text: "Your menstrual calendar and the date of your last menstrual period",
            value: false,
          },
          {
            text: "Family planning tool and types of birth control pills used before",
            value: false,
          },
          {
            text: "If you have had a genital infection before",
            value: false,
          },
          {
            text: "If you have had any abnormal pap smears",
            value: false,
          },
          {
            text: "If you have had any problems, diseases or surgery related to your genitals",
            value: false,
          },
          {
            text: "If you have received fertility treatment before",
            value: false,
          },
          {
            text: "Information about previous abortion, miscarriage or childbirth ",
            value: false,
          },
          {
            text: "If you have had an ectopic or molar pregnancy before",
            value: false,
          },
          {
            text: "If you have diabetes, hypertension, epilepsy, heart problems, thyroid disorders, autoimmune disorders or any serious illness",
            value: false,
          },
          {
            text: "If you are currently suffering from indigestion",
            value: false,
          },
          {
            text: "If you have had a blood transfusion before",
            value: false,
          },
          {
            text: "If you are using any medication",
            value: false,
          },
          {
            text: "A family history of diseases such as cancer, diabetes, keloids or other genetic diseases",
            value: false,
          },
          {
            text: "If you have had chickenpox before or have been vaccinated against chickenpox and diphtheria",
            value: false,
          },
          {
            text: "Your vaccination history",
            value: false,
          },
          {
            text: "If you have had the HPV vaccine",
            value: false,
          },
          {
            text: "Your mental health history: Any history of depression, anxiety disorder or other mental health disorders",
            value: false,
          },
          {
            text: "If you are allergic to certain drugs, substances or foods",
            value: false,
          },
          {
            text: "If you have had problems with anesthesia before.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Keep a pregnancy diary - if there is anything that worries you, talk to your obstetrician.",
            value: false,
          },
          {
            text: "Do not self-medicate, even with pharmacy drugs.",
            value: false,
          },
          {
            text: "If you suffer from nausea or acute fatigue, get enough rest.",
            value: false,
          },
          {
            text: "Get support from your partner for your mental and physical health during pregnancy.",
            value: false,
          },
          {
            text: "Minimize stress and sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Adopt a healthy lifestyle that includes appropriate exercise.",
            value: false,
          },
          {
            text: "Avoid beauty care products with harmful chemicals.",
            value: false,
          },
          {
            text: "If your breasts have grown in size, you may need a new bra.",
            value: false,
          },
          {
            text: "Wear comfortable, cotton clothes.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if ...",
        checklists: [
          {
            text: "You experience spotting (although it can occur in the early stages of pregnancy, spotting can also be a sign of early miscarriage or ectopic pregnancy)",
            value: false,
          },
          {
            text: "You have a fever higher than 38 °C",
            value: false,
          },
          {
            text: "You experience pain or burning sensation when urinating.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 9,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "Due to the rapid growth of your little one, you may feel hungry every few hours.",
            value: false,
          },
          {
            text: "As your baby grows, you may experience back pain from the pressure on your back.",
            value: false,
          },
          {
            text: "As your baby grows, you may experience back pain from the pressure on your back.",
            value: false,
          },
          {
            text: "You may start to experience leg cramps.",
            value: false,
          },
          {
            text: "You may be experiencing heartburn, indigestion, and/or constipation.",
            value: false,
          },
          {
            text: "Cracks may have started to appear.",
            value: false,
          },
          {
            text: "You may experience swollen, irritated and bleeding gums due to high pregnancy hormones.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Avoid consuming raw food.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they help the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Take a pregnancy vitamin recommended by your doctor.",
            value: false,
          },
          {
            text: "Avoid foods containing preservatives as much as possible.",
            value: false,
          },
          {
            text: "Consume less salt to have minimum water retention.",
            value: false,
          },
          {
            text: "Lead a healthy and hygienic lifestyle to avoid infections because your immune system weakens during pregnancy.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 15 kg)",
            value: false,
          },
          {
            text: "Triple screening or quadruple test (between 16. and 18. weeks) - to assess your baby`s risk of having a neural tube defect (NTD), down syndrome or other chromosomal defects",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Amniocentesis (week 16 to week 20) - detects chromosomal abnormalities, neural tube defects and genetic disorders",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "If you are over 35, ask about getting an amniocentesis test.",
            value: false,
          },
          {
            text: "Ask about the possibility of a vaginal delivery if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask your doctor about placental position.",
            value: false,
          },
          {
            text: "Ask for tests such as triple screening to determine if your child is at high risk of down syndrome and neural tube defects such as trisomy 18 (chromosomal abnormalities) and spina bifida.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Sit upright and do light exercises such as pregnancy yoga.",
            value: false,
          },
          {
            text: "Sleep on your side.",
            value: false,
          },
          {
            text: "Lift your feet if they are swollen.",
            value: false,
          },
          {
            text: "Practice breathing techniques before going to sleep.",
            value: false,
          },
          {
            text: "Consider getting a pregnancy massage from a professional.",
            value: false,
          },
          {
            text: "Get a pregnancy pillow to help you sleep better.",
            value: false,
          },
          {
            text: "Choose safe cosmetic products that do not contain chemicals and preservatives.",
            value: false,
          },
          {
            text: "Avoid being around smokers.",
            value: false,
          },
          {
            text: "If your feet are swollen and increased in size, buy new shoes.",
            value: false,
          },
          {
            text: "Keep your teeth and mouth clean and healthy.",
            value: false,
          },
          {
            text: "Avoid stress and try to sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Apply a good stretch cream on your belly.",
            value: false,
          },
          {
            text: "Spend a minimum of 10-15 minutes a day to bond with your baby by singing or talking to your baby.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Register for a birth class.",
            value: false,
          },
          {
            text: "Learn about pregnancy-friendly exercise in the second trimester.",
            value: false,
          },
          {
            text: "Find out how your partner can be more involved in your pregnancy and after the baby is born.",
            value: false,
          },
          {
            text: "Start planning your maternity leave - find out how long you are entitled to.",
            value: false,
          },
          {
            text: "If you sit in one place for long periods of time, remember to stretch lightly from time to time.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "If you have a fever higher than 38 °C",
            value: false,
          },
          {
            text: "If you smell excessive or bad",
            value: false,
          },
          {
            text: "If you are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "If you experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "If you feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "If you feel pain while urinating",
            value: false,
          },
          {
            text: "If your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "If you are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "If you have a severe headache.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 10,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may start to feel pregnancy cramps as your abdominal ligaments will be stretched due to your growing uterus.",
            value: false,
          },
          {
            text: "Your breasts will feel tender and swollen.",
            value: false,
          },
          {
            text: "You may feel more tired than usual.",
            value: false,
          },
          {
            text: "Your sense of smell will increase.",
            value: false,
          },
          {
            text: "You may experience nausea or bloating.",
            value: false,
          },
          {
            text: "You may have acne due to hormonal changes.",
            value: false,
          },
          {
            text: "You may experience mood swings.",
            value: false,
          },
          {
            text: "You may experience back pain.",
            value: false,
          },
          {
            text: "You may experience increased hunger, food cravings and/or food aversion.",
            value: false,
          },
          {
            text: "You may experience loss of appetite.",
            value: false,
          },
          {
            text: "You may experience increased vaginal discharge.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Pay attention to your sugar and salt intake.",
            value: false,
          },
          {
            text: "Avoid consuming raw food.",
            value: false,
          },
          {
            text: "Take a pregnancy vitamin recommended by your doctor.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Avoid foods containing preservatives as much as possible.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Ultrasound dating to calculate expected due date (EDD)",
            value: false,
          },
          {
            text: "Height, weight and body mass index (BMI) control",
            value: false,
          },
          {
            text: "Blood tests (anytime in the first trimester) - to check complete blood count, blood type, hepatitis, sexually transmitted diseases (HIV, syphilis) and immunity to rubella, chickenpox",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Non-Invasive Prenatal Test (NIPT) (week 9 to week 14) - to screen for chromosomal disorders such as down syndrome",
            value: false,
          },
          {
            text: "Chorionic Villus Sampling (CVS) (between week 10 and week 12) - testing for chromosomal abnormalities such as down syndrome",
            value: false,
          },
          {
            text: "Visit the dentist to have your dental health checked",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask about your estimated date of birth.",
            value: false,
          },
          {
            text: "Talk to your doctor about any medication you`re taking, whether prescription or over-the-counter, and check whether it`s safe to continue with them.",
            value: false,
          },
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask your doctor about necessary tests and screening to detect genetic abnormalities.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Try to sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Consult your doctor to continue your sport or exercise routine.",
            value: false,
          },
          {
            text: "Avoid beauty care products that use harmful chemicals.",
            value: false,
          },
          {
            text: "Get a new bra to accommodate changes in your breast size.",
            value: false,
          },
          {
            text: "Tell your closest friends / relatives about your pregnancy.",
            value: false,
          },
          {
            text: "Wash your hands frequently to avoid a cold or flu.",
            value: false,
          },
          {
            text: "Avoid carrying heavy items - ask for help if you need it.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about healthy eating and which foods you should avoid.",
            value: false,
          },
          {
            text: "Create a baby budget.",
            value: false,
          },
          {
            text: "Find out what your health insurance covers or how to get care if you don`t have insurance.",
            value: false,
          },
          {
            text: "Learn about pregnancy-friendly exercise.",
            value: false,
          },
          {
            text: "Learn about breastfeeding and why it is so important.",
            value: false,
          },
          {
            text: "Research on where to deliver your baby - deciding in which hospital your baby will be delivered is a big decision.",
            value: false,
          },
          {
            text: "If you ara a working mother find out your company`s policies for pregnant women.",
            value: false,
          },
          {
            text: "Make sure the office environment is safe for your pregnancy.",
            value: false,
          },
          {
            text: "Inform your manager about your pregnancy.",
            value: false,
          },
          {
            text: "Find out your company`s maternity leave policies and other rights you are entitled to.",
            value: false,
          },
          {
            text: "If you sit in one place for a long time, do not forget to stretch your body from time to time, walk around.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You have a fever higher than 38°C.",
            value: false,
          },
          {
            text: "If you are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "If you experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "If you feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "If you feel pain while urinating",
            value: false,
          },
          {
            text: "If your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "If you are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "If you have a severe headache.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Your Pregnancy may be More Risky...",
        checklists: [
          {
            text: "If you are overweight or underweight",
            value: false,
          },
          {
            text: "If you have anemia",
            value: false,
          },
          {
            text: "If you have a serious infection",
            value: false,
          },
          {
            text: "If you are carrying twins or more",
            value: false,
          },
          {
            text: "If you have cancer, epilepsy, hypertension or any other serious health condition",
            value: false,
          },
          {
            text: "If you have ever had miscarriage, premature birth, preeclampsia or eclampsia",
            value: false,
          },
          {
            text: "If you are under 17 or over 35.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 11,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "Nausea and vomiting may begin to decrease.",
            value: false,
          },
          {
            text: "You may still experience headaches and mood swings.",
            value: false,
          },
          {
            text: "You may feel more tired than usual..",
            value: false,
          },
          {
            text: "You may be feeling more hungry these days.",
            value: false,
          },
          {
            text: "You may experience a lot of bloating, burping and gas.",
            value: false,
          },
          {
            text: "You may also feel uncomfortable after eating.",
            value: false,
          },
          {
            text: "You may experience occasional fainting or dizziness.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Pay attention to your sugar and salt intake.",
            value: false,
          },
          {
            text: "Avoid consuming raw food.",
            value: false,
          },
          {
            text: "Get up slowly, do not skip meals, and avoid standing in one place for long periods of time. These help prevent dizziness.",
            value: false,
          },
          {
            text: "Take a pregnancy vitamin recommended by your doctor.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Avoid foods containing preservatives as much as possible.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Height, weight and body mass index (BMI) control",
            value: false,
          },
          {
            text: "Blood tests (anytime in the first trimester) - to check complete blood count, blood type, hepatitis, sexually transmitted diseases (HIV, syphilis) and immunity to rubella, chickenpox",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Non-Invasive Prenatal Test (NIPT) (week 9 to week 14) - to screen for chromosomal disorders such as down syndrome",
            value: false,
          },
          {
            text: "Chorionic Villus Sampling (CVS) (between week 10 and week 12) - testing for chromosomal abnormalities such as down syndrome",
            value: false,
          },
          {
            text: "One stop clinic for risk assessment for fetal anomalies (OSCAR) (weeks 11 and 14) - to diagnose and calculate the risk of chromosomal and other genetic disorders such as down syndrome and trisomy 18.",
            value: false,
          },
          {
            text: "Visit the dentist to have your dental health checked.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Doktorunuza tahmini son tarihinizi sorun.",
            value: false,
          },
          {
            text: "Talk to your doctor about any medication you`re taking, whether prescription or over-the-counter, and check whether it`s safe to continue with them.",
            value: false,
          },
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask your doctor about necessary tests and screening to detect genetic abnormalities.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Try to sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Consult your doctor to continue your sport or exercise routine.",
            value: false,
          },
          {
            text: "Avoid beauty care products that include harmful chemicals.",
            value: false,
          },
          {
            text: "Moisturize your belly, buttocks, and thighs daily to prevent itchy and dry skin as you stretch and grow.",
            value: false,
          },
          {
            text: "Doing pelvic floor exercises can prevent urine leaks. Squeeze your pelvic floor for 10 seconds. Do 10 repetitions three or four times a day.",
            value: false,
          },
          {
            text: "Reduce household workload - seek help from your spouse or other family members.",
            value: false,
          },
          {
            text: "Wash your hands frequently and keep them clean.",
            value: false,
          },
          {
            text: "Avoid carrying heavy items - ask for help if you need it.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about healthy eating and which foods you should avoid.",
            value: false,
          },
          {
            text: "Create a baby budget.",
            value: false,
          },
          {
            text: "Find out what your health insurance covers or how to get care if you don`t have insurance.",
            value: false,
          },
          {
            text: "Learn about pregnancy-friendly exercise.",
            value: false,
          },
          {
            text: "Learn about breastfeeding and why it is so important.",
            value: false,
          },
          {
            text: "Do research on where to deliver your baby.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Find out your company`s policies for pregnant women.",
            value: false,
          },
          {
            text: "Find out if your work and office environments pose any risk to your pregnancy.",
            value: false,
          },
          {
            text: "Inform your manager about your pregnancy.",
            value: false,
          },
          {
            text: "Find out your company`s maternity leave policies and other rights you are entitled to.",
            value: false,
          },
          {
            text: "If you sit in one place for long periods of time, remember to walk or do light exercises occasionally.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You have a fever higher than 38 °C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You feel pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Your Pregnancy May Be More Risky if...",
        checklists: [
          {
            text: "You are overweight or underweight",
            value: false,
          },
          {
            text: "You have anemia",
            value: false,
          },
          {
            text: "You have a serious infection",
            value: false,
          },
          {
            text: "You are carrying twins or more",
            value: false,
          },
          {
            text: "You have cancer, epilepsy, hypertension or another serious health condition",
            value: false,
          },
          {
            text: "You have ever had miscarriage, premature birth, preeclampsia or eclampsia",
            value: false,
          },
          {
            text: "You are under 17 or over 35.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 12,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You probably no longer experience nausea and vomiting and your appetite is returning to normal.",
            value: false,
          },
          {
            text: "Your gums may be more sensitive; it may bleed even when you brush or floss.",
            value: false,
          },
          {
            text: "Skin discoloration (called chloasma or melasma) may begin to appear gradually.",
            value: false,
          },
          {
            text: "You may be experiencing dizziness.",
            value: false,
          },
          {
            text: "Abdominal muscles become less active, making you prone to constipation and bloating.",
            value: false,
          },
          {
            text: "You may feel that your belly is a little tight and your old clothes are tightening.",
            value: false,
          },
          {
            text: "You may become increasingly sensitive to odor.",
            value: false,
          },
          {
            text: "Belly cramps may be more frequent as your uterus grows, especially if you are active or coughing.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Avoid consuming raw food.",
            value: false,
          },
          {
            text: "Get up slowly, do not skip meals, and avoid standing in one place for long periods of time.",
            value: false,
          },
          {
            text: "Take a pregnancy vitamin recommended by your doctor.",
            value: false,
          },
          {
            text: "Pay attention to your sugar and salt intake.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Avoid foods containing preservatives as much as possible.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Height, weight and body mass index (BMI) control",
            value: false,
          },
          {
            text: "Blood tests (anytime in the first trimester) - to check complete blood count, blood type, hepatitis, sexually transmitted diseases (HIV, syphilis) and immunity to rubella, chickenpox",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Non-Invasive Prenatal Test (NIPT) (between week 9 to week 14) - to screen for chromosomal disorders such as down syndrome",
            value: false,
          },
          {
            text: "Chorionic Villus Sampling (CVS) (between week 10 and week 12) - testing for chromosomal abnormalities such as down syndrome",
            value: false,
          },
          {
            text: "One-stop clinic (between week 11 and week 14) for risk assessment for fetal anomalies (OSCAR) for diagnosis and risk estimation of chromosomal and other genetic disorders such as down syndrome and trisomy 18",
            value: false,
          },
          {
            text: "Visit the dentist to have your dental health checked.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask your doctor about your estimated due date.",
            value: false,
          },
          {
            text: "Talk to your doctor about any medication you`re taking, whether prescription or over-the-counter, and check whether it`s safe to continue with them.",
            value: false,
          },
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask your doctor about necessary tests and screening to detect genetic abnormalities.",
            value: false,
          },
          {
            text: "Ask your doctor about flu and other vaccines.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Try to sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Consult your doctor to continue your sport or exercise routine.",
            value: false,
          },
          {
            text: "Start shopping for larger outfits such as stretchy tops and dresses.",
            value: false,
          },
          {
            text: "Avoid beauty care products that use harmful chemicals.",
            value: false,
          },
          {
            text: "Moisturize your belly, buttocks and thighs daily to prevent itchy and dry skin as you stretch from growth.",
            value: false,
          },
          {
            text: "Doing pelvic floor exercises can prevent urine leaks. Squeeze your pelvic floor for 10 seconds. Do 10 repetitions three or four times a day",
            value: false,
          },
          {
            text: "Take good care of your teeth. Make sure you brush thoroughly twice a day and floss at least three times a week.",
            value: false,
          },
          {
            text: "Avoid sleeping on your back - sleep on your side instead.",
            value: false,
          },
          {
            text: "Wash your hands frequently and keep them clean.",
            value: false,
          },
          {
            text: "Avoid carrying heavy items - ask for help if you need it.",
            value: false,
          },
          {
            text: "Continue pregnancy exercise or yoga with your doctor`s approval.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about healthy eating and which foods you should avoid.",
            value: false,
          },
          {
            text: "Search hospitals to give birth - when choosing don`t forget to consider how far the hospital is from your home.",
            value: false,
          },
          {
            text: "Create a baby budget.",
            value: false,
          },
          {
            text: "Learn about pregnancy-friendly exercise.",
            value: false,
          },
          {
            text: "Learn about breastfeeding and why it is so important.",
            value: false,
          },
          {
            text: "Find out what your health insurance covers or how to get care if you don`t have insurance.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Find out your company`s policies for pregnant women.",
            value: false,
          },
          {
            text: "Find out if your work and office environments pose any risk to your pregnancy.",
            value: false,
          },
          {
            text: "Find out your company`s maternity leave policies and other rights you are entitled to.",
            value: false,
          },
          {
            text: "If you sit in one place for a long time, remember to do some light walking and movements from time to time.",
            value: false,
          },
          {
            text: "Inform your manager about your pregnancy.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if ...",
        checklists: [
          {
            text: "You have a fever higher than 38°C.",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You feel pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Your Pregnancy May Be More Risky if ...",
        checklists: [
          {
            text: "You are overweight or underweight",
            value: false,
          },
          {
            text: "You have anemia",
            value: false,
          },
          {
            text: "You have a serious infection",
            value: false,
          },
          {
            text: "You are carrying twins or more",
            value: false,
          },
          {
            text: "You have cancer, epilepsy, hypertension or another serious health condition",
            value: false,
          },
          {
            text: "You have ever had miscarriage, premature birth, preeclampsia or eclampsia",
            value: false,
          },
          {
            text: "You are under 17 or over 35.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 13,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You are probably no longer experiencing nausea and vomiting and your appetite is returning to normal.",
            value: false,
          },
          {
            text: "A clear and milky discharge known as leucorrhea may increase at this point in your pregnancy.",
            value: false,
          },
          {
            text: "As your uterus grows, abdomen cramps may become more frequent, especially when moving or coughing.",
            value: false,
          },
          {
            text: "You may experience gingivitis, especially if you don`t take good care of your teeth.",
            value: false,
          },
          {
            text: "You`re probably starting to get the pregnancy glow.",
            value: false,
          },
          {
            text: "Your hair will have a fuller and brighter sensation.",
            value: false,
          },
          {
            text: "You may be experiencing dizziness.",
            value: false,
          },
          {
            text: "You may be experiencing constipation, heartburn, and/or indigestion.",
            value: false,
          },
          {
            text: "You may feel an increase or decrease in sexual desire.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia..",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Avoid consuming raw food.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they help the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Take a pregnancy vitamin recommended by your doctor.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Watch your sugar and salt intake.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Height, weight and body mass index (BMI) control",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Non-Invasive Prenatal Test (NIPT) (between week 9 to week 14) - to screen for chromosomal disorders such as down syndrome",
            value: false,
          },
          {
            text: "One-stop clinic for risk assessment for fetal anomalies (OSCAR) for diagnosis and risk estimation of chromosomal and other genetic disorders such as down syndrome and trisomy 18",
            value: false,
          },
          {
            text: "Visit the dentist to have your dental health checked.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask about your situation and estimated due date.",
            value: false,
          },
          {
            text: "Ask if there is any risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask your doctor about necessary tests and screening to detect genetic abnormalities.",
            value: false,
          },
          {
            text: "Ask if you are gaining the right amount of weight.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Consult your obstetrician if you are worried about anything.",
            value: false,
          },
          {
            text: "Do not self-medicate, even with pharmacy drugs.",
            value: false,
          },
          {
            text: "Try to sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Consult your doctor to continue your sport or exercise routine.",
            value: false,
          },
          {
            text: "Start shopping for larger outfits such as stretchy tops and dresses.",
            value: false,
          },
          {
            text: "Avoid beauty care products that use harmful chemicals.",
            value: false,
          },
          {
            text: "Moisturize your belly, buttocks and thighs daily to prevent itchy and dry skin as it stretches from growth.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your baby by singing or talking to it.",
            value: false,
          },
          {
            text: "Open a savings account for your baby.",
            value: false,
          },
          {
            text: "Avoid sleeping on your back and sleep on your side instead.",
            value: false,
          },
          {
            text: "Wash your hands frequently and keep them clean.",
            value: false,
          },
          {
            text: "Avoid carrying heavy items - ask for help if you need it.",
            value: false,
          },
          {
            text: "Consider getting a pregnancy massage from an experienced masseuse..",
            value: false,
          },
          {
            text: "If this is your second pregnancy or more, prepare your first child for your new pregnancy.",
            value: false,
          },
          {
            text: "If this is your second pregnancy or more, prepare your first children for a new sister/brother.",
            value: false,
          },
          {
            text: "Do your Kegel exercises. Squeeze your pelvic floor for 10 seconds. Do 10 repetitions three or four times a day.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about healthy eating and which foods you should avoid.",
            value: false,
          },
          {
            text: "Search hospitals where you will give birth (when choosing one, remember to consider how far the hospital is from your home).",
            value: false,
          },
          {
            text: "Learn about different birth methods.",
            value: false,
          },
          {
            text: "Plan for Babymoon.",
            value: false,
          },
          {
            text: "Learn about breastfeeding and why it`s so important.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Find out your company`s policies for pregnant women.",
            value: false,
          },
          {
            text: "Find out if your work and office environments pose any risk to your pregnancy.",
            value: false,
          },
          {
            text: "Find out your company`s maternity leave policies and other rights you are entitled to.",
            value: false,
          },
          {
            text: "Do not forget to get up and do light walking and exercise when you sit for a long time.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You have severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You feel pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Your Pregnancy May Be More Risky if...",
        checklists: [
          {
            text: "You are overweight or underweight",
            value: false,
          },
          {
            text: "You have anemia",
            value: false,
          },
          {
            text: "You have a serious infection",
            value: false,
          },
          {
            text: "You are carrying twins or more",
            value: false,
          },
          {
            text: "You have cancer, epilepsy, hypertension or another serious health condition",
            value: false,
          },
          {
            text: "You have ever had miscarriage, premature birth, preeclampsia or eclampsia",
            value: false,
          },
          {
            text: "You are under 17 or over 35.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 14,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You will likely have a visible baby bump.",
            value: false,
          },
          {
            text: "You may feel hungry more often now that the nausea has stopped and you have regained your appetite.",
            value: false,
          },
          {
            text: "You may feel discomfort or pain, especially in the back and abdomen.",
            value: false,
          },
          {
            text: "Your hair will be thicker and your skin will be radiant.",
            value: false,
          },
          {
            text: "You may be more clumsy since your joints are looser.",
            value: false,
          },
          {
            text: "You may have a stuffy nose and occasional nosebleeds due to higher pregnancy hormone levels.",
            value: false,
          },
          {
            text: "You may have varicose or enlarged veins in your legs and feet.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day - This is important for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Avoid consuming raw food.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they support the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Take a pregnancy vitamin recommended by your doctor.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Avoid foods containing preservatives as much as possible.",
            value: false,
          },
          {
            text: "Consume less salt to have minimum water retention.",
            value: false,
          },
          {
            text: "Sit upright to avoid back pain.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Height, weight and body mass index (BMI) control",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Non-Invasive Prenatal Test (NIPT) (between week 9 to week 14) - to screen for chromosomal disorders such as down syndrome",
            value: false,
          },
          {
            text: "One stop clinic (OSCAR) for risk assessment for fetal anomalies (midweek) (between weeks 11 and 14) - to diagnose and calculate the risk of chromosomal and other genetic disorders such as down syndrome and trisomy 18",
            value: false,
          },
          {
            text: "Visit the dentist to maintain your dental health",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask your doctor about your condition and estimated due date.",
            value: false,
          },
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask your doctor about necessary tests and screening to detect genetic abnormalities.",
            value: false,
          },
          {
            text: "Ask if you are gaining the right amount of weight.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Sign up for pregnancy classes to prepare your body for childbirth.",
            value: false,
          },
          {
            text: "Get stylish maternity clothes.",
            value: false,
          },
          {
            text: "Keep your teeth and mouth clean and healthy.",
            value: false,
          },
          {
            text: "Write down anything that worries you and clear any doubts with your obstetrician.",
            value: false,
          },
          {
            text: "Meditate to relax.",
            value: false,
          },
          {
            text: "Sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Avoid beauty care products that use harmful chemicals.",
            value: false,
          },
          {
            text: "Consult your doctor to continue your sport or exercise routine.",
            value: false,
          },
          {
            text: "Start using proper creams on your belly to minimize stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes per day for stimulating your baby by singing or talking to it and playing soothing, calming music.",
            value: false,
          },
          {
            text: "Learn about birth.",
            value: false,
          },
          {
            text: "Avoid sleeping on your back - sleep on your side instead.",
            value: false,
          },
          {
            text: "Wash your hands frequently and keep them clean.",
            value: false,
          },
          {
            text: "Avoid carrying heavy items - ask for help if you need it.",
            value: false,
          },
          {
            text: "Consider getting a pregnancy massage from an experienced masseuse.",
            value: false,
          },
          {
            text: "If this is your second pregnancy or more, prepare your first children for a new sister/brother.",
            value: false,
          },
          {
            text: "Do your Kegel exercises. Squeeze your pelvic floor for 10 seconds. Do 10 repetitions three or four times a day.",
            value: false,
          },
          {
            text: "Plan for Babymoon!",
            value: false,
          },
          {
            text: "Do yoga and pilates to relieve your discomfort.",
            value: false,
          },
          {
            text: "Avoid intense exercise that could cause you to fall.",
            value: false,
          },
          {
            text: "Consider opening a savings fund for your child.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Find out prenatal courses in your area.",
            value: false,
          },
          {
            text: "Learn about pregnancy-friendly exercise.",
            value: false,
          },
          {
            text: "Find out how your partner can be more involved during your pregnancy and after the baby is born.",
            value: false,
          },
          {
            text: "Decide in which hospital you will give birth. When choosing one, remember to consider how far the hospital is from your home. Also, check if your obstetrician has visited that hospital.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Find out your company`s policies for pregnant women.",
            value: false,
          },
          {
            text: "Find out if your work and office environments pose any risk to your pregnancy.",
            value: false,
          },
          {
            text: "Find out your company`s maternity leave policies and other rights you are entitled to.",
            value: false,
          },
          {
            text: "If you sit in one place for a long time, remember to stretch your body from time to time.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if ...",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You feel pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 15,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "Your nose and gums may swell due to increased levels of pregnancy hormones.",
            value: false,
          },
          {
            text: "Your gums may bleed.",
            value: false,
          },
          {
            text: "You may have milky vaginal discharge.",
            value: false,
          },
          {
            text: "You may feel back pain.",
            value: false,
          },
          {
            text: "Your nipples may darken and enlarge.",
            value: false,
          },
          {
            text: "You may be experiencing constipation, heartburn, and/or indigestion.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "As your immune system weakens during pregnancy, lead a healthy lifestyle to avoid infections.",
            value: false,
          },
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Avoid consuming raw food.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they help the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Take a pregnancy vitamin recommended by your doctor.",
            value: false,
          },
          {
            text: "Make sure you`re getting enough calcium and vitamin D to help absorb calcium.",
            value: false,
          },
          {
            text: "Avoid foods containing preservatives as much as possible.",
            value: false,
          },
          {
            text: "Consume less salt to have minimum water retention.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Do the necessary blood tests recommended by your doctor.",
            value: false,
          },
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg).",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },

          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check the protein levels in your urine.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Request tests to determine if your child is at increased risk for down syndrome and neural tube defects such as trisomy 18 (chromosomal abnormalities) and spina bifida.",
            value: false,
          },
          {
            text: "If you are over 35, ask about getting an amniocentesis test.",
            value: false,
          },
          {
            text: "Ask about birth options.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Keep your environment clean to stay healthy.",
            value: false,
          },
          {
            text: "Wash your hands regularly and always have a hand sanitizer with you to protect yourself from the common cold or flu.",
            value: false,
          },
          {
            text: "Find safe and comfortable sexual positions for you and your partner.",
            value: false,
          },
          {
            text: "Keep your teeth and mouth clean and healthy.",
            value: false,
          },
          {
            text: "Meditate to relax.",
            value: false,
          },
          {
            text: "Sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Sign up for pregnancy classes to prepare your body for childbirth.",
            value: false,
          },
          {
            text: "Write down any conditions that worry you and talk to your obstetrician about them.",
            value: false,
          },
          {
            text: "Avoid beauty care products that use harmful chemicals.",
            value: false,
          },
          {
            text: "Start using a good spot cream on your belly to minimize stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your baby by singing or talking to your baby and playing soothing, calming music.",
            value: false,
          },
          {
            text: "Avoid sleeping on your back - sleep on your side instead.",
            value: false,
          },
          {
            text: "Wash your hands frequently and keep them clean.",
            value: false,
          },
          {
            text: "Avoid carrying heavy items - ask for help if you need it.",
            value: false,
          },
          {
            text: "Consider getting a pregnancy massage from an experienced masseuse.",
            value: false,
          },
          {
            text: "If this is your second pregnancy or more, prepare your first children for a new sister/brother.",
            value: false,
          },
          {
            text: "Do your Kegel exercises. Squeeze your pelvic floor for 10 seconds. Do 10 repetitions three or four times a day.",
            value: false,
          },
          {
            text: "Plan for Babymoon!",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about different birth methods.",
            value: false,
          },
          {
            text: "Learn about pregnancy-friendly exercise.",
            value: false,
          },
          {
            text: "Learn about breastfeeding and why it`s so important.",
            value: false,
          },
          {
            text: "Find out how your partner can be more involved in your pregnancy and after the baby is born.",
            value: false,
          },
          {
            text: "Decide in which hospital you will give birth - remember to consider how far the hospital is from your home.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Find out your company`s policies for pregnant women.",
            value: false,
          },
          {
            text: "Find out if your work and office environments pose any risk to your pregnancy.",
            value: false,
          },
          {
            text: "Find out your company`s maternity leave policies and other rights you are entitled to.",
            value: false,
          },
          {
            text: "If you sit in one place for long periods of time, remember to stretch lightly from time to time.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if ...",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge.",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea.",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain.",
            value: false,
          },
          {
            text: "You feel pain while urinating.",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen.",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding.",
            value: false,
          },
          {
            text: "You have a severe headache.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 16,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: 'You can feel your baby`s first beats - this is known as "speeding up" and you may feel like soft bubbles or a butterfly fluttering in your stomach!',
            value: false,
          },
          {
            text: "Your gums may be red, swollen and even painful, tender or prone to bleeding when you brush or floss your teeth.",
            value: false,
          },
          {
            text: "You may experience constipation as your uterus presses on your intestines.",
            value: false,
          },
          {
            text: "Your hair and nails start to grow faster.",
            value: false,
          },
          {
            text: "You may experience dry and itchy skin.",
            value: false,
          },
          {
            text: "You may experience heartburn.",
            value: false,
          },
          {
            text: "You may be more forgetful.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they help the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Take a pregnancy vitamin recommended by your doctor.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Avoid foods containing preservatives as much as possible.",
            value: false,
          },
          {
            text: "Consume less salt to have minimum water retention.",
            value: false,
          },
          {
            text: "Koruyucu içeren gıdalardan mümkün olduğunca kaçının.",
            value: false,
          },
          {
            text: "Maintain a healthy lifestyle to avoid infections because your immune system is weaker.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Do the necessary blood tests as recommend by your doctor.",
            value: false,
          },
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg).",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Amniocentesis (between week 16 and week 20) - detects chromosomal abnormalities, neural tube defects and genetic disorders.",
            value: false,
          },
          {
            text: "Triple screening or quadruple test (between 16 and 18 weeks) - to assess your baby`s risk of having a neural tube defect (NTD), Down syndrome or other chromosomal defects.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask about tests such as triple screening to determine if your child is at increased risk for down syndrome and neural tube defects such as trisomy 18 (chromosomal abnormalities) and spina bifida.",
            value: false,
          },
          {
            text: "If you are over 35, ask about getting an amniocentesis test.",
            value: false,
          },
          {
            text: "Talk to your doctor about birth options.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Use a good moisturizer to reduce the appearance of stretch marks.",
            value: false,
          },
          {
            text: "Ask your husband to talk to your baby so that it is familiar with its father`s voice.",
            value: false,
          },
          {
            text: "Sign up for a pregnancy class.",
            value: false,
          },
          {
            text: "If you think you are forgetful, list the things you need to do.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about different birth methods.",
            value: false,
          },
          {
            text: "Learn about pregnancy-friendly exercise in the second trimester.",
            value: false,
          },
          {
            text: "Learn about breastfeeding and why it is so important.",
            value: false,
          },
          {
            text: "Find out how your partner can be more involved in your pregnancy and after the baby is born.",
            value: false,
          },
          {
            text: "Find out what your baby is doing this week.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Find out your workplace`s policies for pregnant women.",
            value: false,
          },
          {
            text: "Find out if your work and office environments pose any risk to your pregnancy.",
            value: false,
          },
          {
            text: "Find out your company`s maternity leave policies and other rights you are entitled to.",
            value: false,
          },
          {
            text: "If you sit in one place for a long time, remember to stretch lightly from time to time.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if ...",
        checklists: [
          {
            text: "You have a fever greater than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You have severe or persistent abdominal painz",
            value: false,
          },
          {
            text: "You feel pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 17,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You gain weight as your baby continues to grow.",
            value: false,
          },
          {
            text: "You may notice stretch marks on your belly, chest and even on your arms and thighs.",
            value: false,
          },
          {
            text: "You may sweat more due to the increase in blood flow and body fluids.",
            value: false,
          },
          {
            text: "A dark line may appear in the middle of your abdomen. This is called the linea nigra.",
            value: false,
          },
          {
            text: "You will probably feel more hungry in these days.",
            value: false,
          },
          {
            text: "Changes in hormone levels can cause skin pigmentation.",
            value: false,
          },
          {
            text: "You may be experiencing heartburn, indigestion, and/or constipation.",
            value: false,
          },
          {
            text: "Your sleep may be interrupted by leg cramps.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Avoid consuming raw food.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they help the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Take a pregnancy vitamin recommended by your doctor.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Avoid foods containing preservatives as much as possible.",
            value: false,
          },
          {
            text: "Consume less salt to have minimum water retention.",
            value: false,
          },
          {
            text: "Lead a healthy lifestyle to avoid infections because your immune system is weakened during pregnancy.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Take the necessary blood tests recommended by your doctor.",
            value: false,
          },
          {
            text: "Visit your dentist if you haven`t already.",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Amniocentesis (week 16 to week 20) - to detect chromosomal abnormalities, neural tube defects and genetic disorders",
            value: false,
          },
          {
            text: "Triple screening or quadruple test (between 16 and 18 weeks) - to assess your baby`s risk of having a neural tube defect (NTD), down syndrome or other chromosomal defects.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "If you are over 35, ask about getting an amniocentesis test.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal birth if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask for tests such as triple screening to determine if your child is at high risk of down syndrome and neural tube defects such as trisomy 18 (chromosomal abnormalities) and spina bifida.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "The pregnancy pillow helps you sleep better.",
            value: false,
          },
          {
            text: "Choose cosmetics that are safe for you to use.",
            value: false,
          },
          {
            text: "Sleep on your left side, never on your back.",
            value: false,
          },
          {
            text: "Check if you need new shoes as your shoe size may increase.",
            value: false,
          },
          {
            text: "Sign up for a pregnancy class.",
            value: false,
          },
          {
            text: "Keep your teeth and mouth clean and healthy.",
            value: false,
          },
          {
            text: "Learn to relax through meditation.",
            value: false,
          },
          {
            text: "Avoid stress and try to sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Apply a good stretch cream on your belly.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your baby by singing or talking to your baby.",
            value: false,
          },
          {
            text: "Consider opening a savings fund for your child.",
            value: false,
          },
          {
            text: "Wash your hands frequently and keep them clean.",
            value: false,
          },
          {
            text: "Practice your Kegel exercises. Squeeze your pelvic floor for 10 seconds. Do 10 repetitions three or four times a day.",
            value: false,
          },
          {
            text: "Complete Babymoon plans.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Register for a birth class.",
            value: false,
          },
          {
            text: "Learn about pregnancy-friendly exercise in the second trimester.",
            value: false,
          },
          {
            text: "Find out how your partner can be more involved in your pregnancy and after the baby is born.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Find out your company`s policies for pregnant women.",
            value: false,
          },
          {
            text: "Find out if your work and office environments pose any risk to your pregnancy.",
            value: false,
          },
          {
            text: "Find out your company`s maternity leave policies and other rights you are entitled to.",
            value: false,
          },
          {
            text: "If you sit in one place for a long time, remember to stretch lightly from time to time.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You have a fever higher than 38 °C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 18,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "Due to the rapid growth of your little one, you may feel hungry every few hours.",
            value: false,
          },
          {
            text: "Your hands and feet may swell.",
            value: false,
          },
          {
            text: "You may feel back pain from the pressure on your back due to the baby`s growth.",
            value: false,
          },
          {
            text: "You may start to experience leg cramps.",
            value: false,
          },
          {
            text: "You may be experiencing heartburn, indigestion, and/or constipation.",
            value: false,
          },
          {
            text: "Cracks may have started to appear.",
            value: false,
          },
          {
            text: "You may experience swollen, irritated and bleeding gums due to increased pregnancy hormones.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take at least 400 mcg of folic acid per day for your baby`s brain and spinal cord development.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat foods rich in iron to prevent anemia.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Reduce your caffeine intake to no more than one cup per day.",
            value: false,
          },
          {
            text: "Avoid consuming raw food.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they help the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Take a pregnancy vitamin recommended by your doctor.",
            value: false,
          },
          {
            text: "Avoid foods containing preservatives as much as possible.",
            value: false,
          },
          {
            text: "Consume less salt to have minimum water retention.",
            value: false,
          },
          {
            text: "Maintain a healthy lifestyle to avoid infections because your immune system is weakened during pregnancy.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Triple screening or quadruple test (between 16 and 18 weeks) - to assess your baby`s risk of having a neural tube defect (NTD), down syndrome or other chromosomal defects",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Amniocentesis (week 16 to week 20) - detects chromosomal abnormalities, neural tube defects and genetic disorders",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "If you are over 35, ask about getting an amniocentesis test.",
            value: false,
          },
          {
            text: "Ask about the possibility of a vaginal delivery if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask for tests such as triple screening to determine if your child is at high risk of down syndrome and neural tube defects such as trisomy 18 (chromosomal abnormalities) and spina bifida.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Sit upright and do light exercises such as pregnancy yoga.",
            value: false,
          },
          {
            text: "Sleep on your side as sleeping on your back can restrict blood flow and cause dizziness.",
            value: false,
          },
          {
            text: "Lift your feet if they are swollen.",
            value: false,
          },
          {
            text: "Consider getting a pregnancy massage from a professional.",
            value: false,
          },
          {
            text: "Get a pregnancy pillow to help you sleep better.",
            value: false,
          },
          {
            text: "Choose safe cosmetic products that do not contain chemicals and preservatives.",
            value: false,
          },
          {
            text: "Avoid being around smokers.",
            value: false,
          },
          {
            text: "If your feet are swollen and increased in size, buy new shoes.",
            value: false,
          },
          {
            text: "Keep your teeth and mouth clean and healthy.",
            value: false,
          },
          {
            text: "Avoid stress and try to sleep at least 8 hours.",
            value: false,
          },
          {
            text: "Apply a good moisturizing cream to your abdominal region.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your baby by singing or talking to your baby.",
            value: false,
          },
          {
            text: "Take time to meet with your friends.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Register for a birth class.",
            value: false,
          },
          {
            text: "Learn about pregnancy-friendly exercise in the second trimester.",
            value: false,
          },
          {
            text: "Find out how your partner can be more involved in your pregnancy and after the baby is born.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Start planning your maternity leave - find out how long you are entitled to.",
            value: false,
          },
          {
            text: "If you sit in one place for a long time, remember to stretch lightly from time to time.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You have a fever higher than 38 °C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 19,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Gebelik Belirtileri",
        checklists: [
          {
            text: "You may feel abdominal pain as it stretches your growing uterine ligaments.",
            value: false,
          },
          {
            text: "You will feel tiny kicks and movements from your little one.",
            value: false,
          },
          {
            text: "You may experience heartburn.",
            value: false,
          },
          {
            text: "You may be more hungry.",
            value: false,
          },
          {
            text: "Cracks may have started to appear.",
            value: false,
          },
          {
            text: "Your nose may be stuffy.",
            value: false,
          },
          {
            text: "You sweat more and feel warmer.",
            value: false,
          },
          {
            text: "You may experience dizziness.",
            value: false,
          },
          {
            text: "There may be leg cramps at night.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat iron-rich foods such as red meat, poultry, fish, lentils, green leafy vegetables and whole grains to prevent anemia.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they help the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Consume less salt to have minimum water retention.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Detailed fetal anomaly scan (week 19 to week 22) - to check for structural abnormalities in the fetus and other details such as placental position",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Amniocentesis (week 16 to week 20) - detects chromosomal abnormalities, neural tube defects and genetic disorders",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "If you are over 35, ask about getting an amniocentesis test.",
            value: false,
          },
          {
            text: "Ask about the possibility of a vaginal delivery if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask your doctor about placental position.",
            value: false,
          },
          {
            text: "If you still haven`t found out, ask your baby`s gender.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Try walking and doing simple exercises - they will keep you fit and relieve pregnancy aches and pains.",
            value: false,
          },
          {
            text: "If you feel dizzy, sit down and do breathing exercises.",
            value: false,
          },
          {
            text: "Sleep with a pillow tucked between your knees to relieve hip and lower back pain.",
            value: false,
          },
          {
            text: "Ask your partner to also feel the baby kicks.",
            value: false,
          },
          {
            text: "Start thinking of names for your baby.",
            value: false,
          },
          {
            text: "Avoid lifting heavy things.",
            value: false,
          },
          {
            text: "Do not lie on your back as it may restrict blood flow around your body.",
            value: false,
          },
          {
            text: "Sleep on your side (preferably on the left).",
            value: false,
          },
          {
            text: "Don`t get too tired; listen to your body!",
            value: false,
          },
          {
            text: "Choose safe cosmetic products that do not contain chemicals and preservatives.",
            value: false,
          },
          {
            text: "Take a picture of your growing belly!",
            value: false,
          },
          {
            text: "If you want, start preparing the baby`s room.",
            value: false,
          },
          {
            text: "Consider getting a pregnancy massage from a professional.",
            value: false,
          },
          {
            text: "Avoid being around smokers.",
            value: false,
          },
          {
            text: "If your feet are swollen and enlarged in size, buy new shoes.",
            value: false,
          },
          {
            text: "Talk to your baby when you feel it kicking.",
            value: false,
          },
          {
            text: "Keep your teeth and mouth clean and healthy.",
            value: false,
          },
          {
            text: "Avoid stress and try to sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Apply a good cream on your abdomen every day.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your baby by singing or talking to your baby.",
            value: false,
          },
          {
            text: "Your breasts will be larger, so consider wearing a supportive bra.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Register for a birth class.",
            value: false,
          },
          {
            text: "Learn about pregnancy-friendly exercise in the second trimester.",
            value: false,
          },
          {
            text: "Find out how your partner can be more involved in your pregnancy and after the baby is born.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Start planning your maternity leave - find out how long you are entitled to.",
            value: false,
          },
          {
            text: "If you sit in one place for a long time, remember to stretch lightly from time to time.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You have a fever higher than 38 °C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 20,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may feel breathless after climbing up a few stairs also.",
            value: false,
          },
          {
            text: "You should be able to feel your baby kicking by now.",
            value: false,
          },
          {
            text: "You may have swelling (edema) in your feet and ankles.",
            value: false,
          },
          {
            text: 'Your belly button may be "protruding".',
            value: false,
          },
          {
            text: "You may have leg cramps at night.",
            value: false,
          },
          {
            text: "You may feel dizzy.",
            value: false,
          },
          {
            text: "You may experience a headache.",
            value: false,
          },
          {
            text: "You may experience heartburn, indigestion and/or constipation.",
            value: false,
          },
          {
            text: "You may have pain in your stomach, groin and/or arm.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat iron-rich foods such as red meat, poultry, fish, lentils, green leafy vegetables and whole grains to prevent anemia.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they help the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Consume less salt to have minimum water retention.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Detailed fetal anomaly scan (week 19 to week 22) - to check for structural abnormalities in the fetus and other details such as placental position",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Amniocentesis (week 16 to week 20) - detects chromosomal abnormalities, neural tube defects and genetic disorders.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "If you are over 35, ask about getting an amniocentesis test.",
            value: false,
          },
          {
            text: "Ask about the possibility of a vaginal delivery if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask your doctor about placental position.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Bring your partner with you for the ultrasound test.",
            value: false,
          },
          {
            text: "Now it`s time to travel! (But check with your doctor first)",
            value: false,
          },
          {
            text: "Open a savings account for your baby`s future.",
            value: false,
          },
          {
            text: "Avoid lifting heavy things.",
            value: false,
          },
          {
            text: "Do not lie on your back as it may restrict blood flow around your body. Sleep on your side (preferably on the left).",
            value: false,
          },
          {
            text: "Don`t push yourself too hard; listen to your body!",
            value: false,
          },
          {
            text: "Choose safe cosmetic products that do not contain chemicals and preservatives.",
            value: false,
          },
          {
            text: "Take a picture of your growing belly!",
            value: false,
          },
          {
            text: "If you want, start preparing the baby`s room.",
            value: false,
          },
          {
            text: "Consider getting a pregnancy massage from a professional.",
            value: false,
          },
          {
            text: "Avoid being around smokers.",
            value: false,
          },
          {
            text: "If your feet are swollen and enlarged, buy new shoes.",
            value: false,
          },
          {
            text: "Keep your teeth and mouth clean and healthy.",
            value: false,
          },
          {
            text: "Avoid stress and try to sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Apply a good cream on your abdomen.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes per day for stimulating your baby by singing or talking to your baby and playing soothing, calming music.",
            value: false,
          },
          {
            text: "Go to Babymoon, the pre-baby honeymoon!",
            value: false,
          },
          {
            text: "Your breasts will be larger, so consider wearing a supportive bra.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Register for a birth class.",
            value: false,
          },
          {
            text: "Learn about pregnancy-friendly exercise in the second trimester.",
            value: false,
          },
          {
            text: "Find out how your partner can be more involved in your pregnancy and after the baby is born.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "If you sit in one place for a long time, remember to stretch lightly from time to time.",
            value: false,
          },
          {
            text: "Start preparing your to-do list before going on maternity leave.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if …",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You feel pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 21,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may notice stretch marks on your belly, chest and even your arms.",
            value: false,
          },
          {
            text: "You may feel itchy on your belly due to stretched skin.",
            value: false,
          },
          {
            text: "You may have swelling (edema) in your feet and ankles.",
            value: false,
          },
          {
            text: "You may have acne.",
            value: false,
          },
          {
            text: "Bluish veins that can turn into varicose veins may occur on your legs.",
            value: false,
          },
          {
            text: "You may have leg cramps at night.",
            value: false,
          },
          {
            text: "You may have pain in your abdomen, groin and/or hip.",
            value: false,
          },
          {
            text: "You may start to feel more shaky and clumsy than usual.",
            value: false,
          },
          {
            text: "You may have swollen and bleeding gums.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat iron-rich foods such as red meat, poultry, fish, lentils, green leafy vegetables and whole grains to prevent anemia.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they help the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Consume less salt to have minimum water retention.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Detailed fetal anomaly scan (week 19 and week 22) - to check for structural abnormalities in the fetus and other details such as placental position",
            value: false,
          },
          {
            text: "Kan basıncı kontrolü",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask about the possibility of a vaginal delivery if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask your doctor about placental position.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Start taking pregnancy classes - bring your partner with you.",
            value: false,
          },
          {
            text: "Lift your feet and ankles for relief if they are swollen.",
            value: false,
          },
          {
            text: "Encourage your husband to talk to your baby.",
            value: false,
          },
          {
            text: "Listen to soothing music to help you relax.",
            value: false,
          },
          {
            text: "Do not lie on your back as it may restrict blood flow around your body. Sleep on your side, preferably on your left.",
            value: false,
          },
          {
            text: "Avoid lifting heavy things.",
            value: false,
          },
          {
            text: "Don`t get too tired; listen to your body!",
            value: false,
          },
          {
            text: "Choose safe cosmetic products that do not contain chemicals and preservatives.",
            value: false,
          },
          {
            text: "Take a picture of your growing belly!",
            value: false,
          },
          {
            text: "If you want, start preparing the baby`s room.",
            value: false,
          },
          {
            text: "Consider getting a pregnancy massage from a professional.",
            value: false,
          },
          {
            text: "Avoid being around smokers.",
            value: false,
          },
          {
            text: "If your feet are swollen and enlarged, buy new shoes.",
            value: false,
          },
          {
            text: "Keep your teeth and mouth clean and healthy.",
            value: false,
          },
          {
            text: "Avoid stress and try to sleep at least 8 hours a day.",
            value: false,
          },
          {
            text: "Apply a good cream on your belly.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes per day for stimulating your baby by singing or talking to your baby and playing soothing, calming music.",
            value: false,
          },
          {
            text: "Go to Babymoon!",
            value: false,
          },
          {
            text: "Your breasts will be larger, so consider wearing a supportive bra.",
            value: false,
          },
          {
            text: "Meet with your friends as you won`t have time to do this when the baby is born.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn as much as possible about breastfeeding, especially right after birth.",
            value: false,
          },
          {
            text: "Learn the pros and cons of different birth methods.",
            value: false,
          },
          {
            text: "Learn ways to relieve birth pain, such as different breathing techniques.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Plan your maternity leave",
            value: false,
          },
          {
            text: "If you sit in one place for a long time, remember to stretch lightly from time to time.",
            value: false,
          },
          {
            text: "Start preparing your to-do list before going on maternity leave.",
            value: false,
          },
          {
            text: "If you`re going back to work after maternity leave, it`s time to start looking for a nanny or babysitting centre.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 22,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "Your growing uterus can press on your ribs, which can cause breathing difficulties.",
            value: false,
          },
          {
            text: "You now have a decent baby bump in your belly!",
            value: false,
          },
          {
            text: "Your belly button may come out.",
            value: false,
          },
          {
            text: "Thanks to pregnancy hormones, you can have thick, shiny hair.",
            value: false,
          },
          {
            text: "You may be experiencing constipation, heartburn, and/or indigestion.",
            value: false,
          },
          {
            text: "Your sleep may be interrupted by leg cramps.",
            value: false,
          },
          {
            text: "You may feel dizzy or lightheaded.",
            value: false,
          },
          {
            text: "Stretch marks may begin to appear on your abdomen, hips, thighs and breasts.",
            value: false,
          },
          {
            text: "You may have swelling (edema) in your feet and ankles.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat iron-rich foods such as red meat, poultry, fish, lentils, green leafy vegetables and whole grains to prevent anemia.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they help the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Consume less salt to have minimum water retention.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Watch your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Detailed fetal anomaly scan (week 19 to week 22) - to check for any structural abnormalities in the fetus and other details such as placental position",
            value: false,
          },
          {
            text: "Do not miss your regular appointments with the obstetrician.",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Go to the dentist at least once during your pregnancy.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask how you are doing in terms of weight gain.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask your doctor about placental position.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Check your posture - use a pillow to support your back if needed.",
            value: false,
          },
          {
            text: "Wear comfortable shoes.",
            value: false,
          },
          {
            text: "Don`t work hard and avoid stress.",
            value: false,
          },
          {
            text: "Attend a pregnancy class.",
            value: false,
          },
          {
            text: "Encourage your husband to interact with your baby.",
            value: false,
          },
          {
            text: "Listen to soothing music to help you relax.",
            value: false,
          },
          {
            text: "Do not lie on your back as it may restrict blood flow around your body. Sleep on your side, preferably on your left.",
            value: false,
          },
          {
            text: "If you have ideas about your baby shower, share them with your friends who are planning it.",
            value: false,
          },
          {
            text: "Pamper yourself with a pedicure or massage.",
            value: false,
          },
          {
            text: "Keep exercising but don`t tire yourself.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Use a pregnancy pillow for better sleep.",
            value: false,
          },
          {
            text: "Use safe cosmetics that do not contain nasty chemicals.",
            value: false,
          },
          {
            text: "Take a picture of your growing belly.",
            value: false,
          },
          {
            text: "Apply a moisturizing body lotion to your abdomen and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your baby by singing or talking to your baby.",
            value: false,
          },
          {
            text: "Your breasts will be larger, so consider wearing a supportive bra.",
            value: false,
          },
          {
            text: "Go to Babymoon! But don`t tire yourself too much while traveling.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "If you are planning to breastfeed, find a good lactation consultant or breastfeeding classes you can sign up for.",
            value: false,
          },
          {
            text: "Learn the pros and cons of different birth methods.",
            value: false,
          },
          {
            text: "Join one or more pregnancy and parent groups online.",
            value: false,
          },
          {
            text: "Search baby room designs.",
            value: false,
          },
          {
            text: "Search for information on cots and bassinets.",
            value: false,
          },
          {
            text: "Learn ways to relieve birth pain, such as different breathing techniques.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Plan your maternity leave with your supervisor and close colleagues.",
            value: false,
          },
          {
            text: "Find out who will take responsibility of your task in your absence.",
            value: false,
          },
          {
            text: "If you sit in one place for a long time, remember to stretch lightly from time to time.",
            value: false,
          },
          {
            text: "Start preparing your to-do list before going on maternity leave.",
            value: false,
          },
          {
            text: "If you`re going back to work after maternity leave, it`s time to start looking for a nanny or babysitting centre.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 23,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may experience snoring and nasal congestion due to increased pregnancy hormones.",
            value: false,
          },
          {
            text: "Your body weight has increased by approximately 5.4 - 6.8 kg.",
            value: false,
          },
          {
            text: "You will want to urinate more often.",
            value: false,
          },
          {
            text: "Your gums and/or nose may bleed due to increased blood flow.",
            value: false,
          },
          {
            text: "You may feel more hungry these days.",
            value: false,
          },
          {
            text: "You may have swelling (edema) in your feet and ankles.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat iron-rich foods such as red meat, poultry, fish, lentils, green leafy vegetables and whole grains to prevent anemia.",
            value: false,
          },
          {
            text: "Eat foods rich in calcium, vitamin D and magnesium as they help the baby`s rapidly developing bones and teeth.",
            value: false,
          },
          {
            text: "Consume less salt to have minimum water retention.",
            value: false,
          },
          {
            text: "Watch your sugar intake.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Visit the dentist if you haven`t already.",
            value: false,
          },
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Do not miss your regular appointments with the obstetrician.",
            value: false,
          },
          {
            text: "How about an ultrasound to check your baby`s development!",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask about the possibility of a vaginal delivery if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask your doctor about placental position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about preterm birth risks.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Share your concerns with your partner to ease your worries.",
            value: false,
          },
          {
            text: "Carry hand sanitizer with you when you go out.",
            value: false,
          },
          {
            text: "Don`t work hard and avoid stress.",
            value: false,
          },
          {
            text: "Attend a pregnancy class.",
            value: false,
          },
          {
            text: "Encourage your husband to interact with your baby.",
            value: false,
          },
          {
            text: "Listen to soothing music to help you relax.",
            value: false,
          },
          {
            text: "Do not lie on your back as it may restrict blood flow around your body.",
            value: false,
          },
          {
            text: "If you have ideas about your baby shower, share them with your friends who are planning it.",
            value: false,
          },
          {
            text: "Pamper yourself with a pedicure or massage.",
            value: false,
          },
          {
            text: "Keep exercising but don`t tire yourself.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Go to Babymoon!",
            value: false,
          },
          {
            text: "Use a pregnancy pillow for better sleep.",
            value: false,
          },
          {
            text: "Use safe cosmetics that do not contain harmful chemicals.",
            value: false,
          },
          {
            text: "Take a picture of your growing belly.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Apply a moisturizing body lotion to your abdomen and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your baby by singing or talking to your baby.",
            value: false,
          },
          {
            text: "Your breasts will be larger, so consider wearing a supportive bra.",
            value: false,
          },
          {
            text: "Continue to do safe and gentle exercises such as walking and yoga.",
            value: false,
          },
          {
            text: "Do Kegel exercises to strengthen your pelvic floor and help with birth pain.",
            value: false,
          },
          {
            text: "If you are sitting in one place for a long time, gently stretch your legs and arms.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "If you are planning to breastfeed, find a good lactation consultant or breastfeeding classes you can sign up for.",
            value: false,
          },
          {
            text: "Search the pros and cons of various birth methods.",
            value: false,
          },
          {
            text: "If you wish, start researching alternative birth methods such as water birth or hypnobirthing.",
            value: false,
          },
          {
            text: "Look for baby room or nursery designs.",
            value: false,
          },
          {
            text: "Join one or more pregnancy, breastfeeding and parenting groups online.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Plan your maternity leave with your supervisor and close colleagues.",
            value: false,
          },
          {
            text: "Find out who will take responsibility of your task in your absence.",
            value: false,
          },
          {
            text: "If you sit in one place for a long time, remember to stretch lightly from time to time.",
            value: false,
          },
          {
            text: "Start preparing your to-do list before going on maternity leave.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 24,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may have swelling (edema) in your feet and ankles.",
            value: false,
          },
          {
            text: "You may have gained 7-8 kg so far.",
            value: false,
          },
          {
            text: "You may see stretch marks on your breasts and abdomen.",
            value: false,
          },
          {
            text: "The linea nigra - a black line running from your navel to your pubic bone - will appear.",
            value: false,
          },
          {
            text: "You may experience migraines and/or blurred vision due to pregnancy hormones.",
            value: false,
          },
          {
            text: "You may interrupt your sleep with leg cramps.",
            value: false,
          },
          {
            text: "You may feel uncomfortable tingling, numbness or pain in your wrists and fingers (carpal tunnel syndrome).",
            value: false,
          },
          {
            text: "You may be experiencing constipation, heartburn, and/or indigestion.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Add low-fat dairy products to your diet for a calcium increase.",
            value: false,
          },
          {
            text: "Consume foods rich in vitamin C and green leafy vegetables.",
            value: false,
          },
          {
            text: "Avoid very acidic foods that can cause reflux.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Consume fresh fruits, vegetables, lean meat and fish with a balanced diet.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Avoid cigarette smoke and alcohol.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Oral Glucose Tolerance Test (GTT) (week 24 to week 28) - to screen for gestational diabetes in the mother. It includes 3 blood tests.",
            value: false,
          },
          {
            text: "Do not miss your regular appointments with the obstetrician.",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Look out for any unusual symptoms and report them to the doctor immediately, if any.",
            value: false,
          },
          {
            text: "Maintain good dental hygiene to reduce the risk of bleeding gums or infection.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask your doctor about placental position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about preterm birth risks.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Share your concerns with your partner to ease your worries.",
            value: false,
          },
          {
            text: "Carry hand sanitizer with you when you go out.",
            value: false,
          },
          {
            text: "Don`t work hard and avoid stress.",
            value: false,
          },
          {
            text: "Attend a pregnancy class.",
            value: false,
          },
          {
            text: "Encourage your husband to interact with your baby.",
            value: false,
          },
          {
            text: "Listen to relaxing music.",
            value: false,
          },
          {
            text: "Do not lie on your back as it may restrict blood flow around your body. Sleep on your side, preferably on your left",
            value: false,
          },
          {
            text: "If you have ideas about your baby shower, share them with your friends who are planning it.",
            value: false,
          },
          {
            text: "Pamper yourself with a pedicure or massage.",
            value: false,
          },
          {
            text: "Continue to do safe and gentle exercises such as walking and yoga.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Go to Babymoon!",
            value: false,
          },
          {
            text: "Use a pregnancy pillow for better sleep.",
            value: false,
          },
          {
            text: "Use safe cosmetics that do not contain harmful chemicals.",
            value: false,
          },
          {
            text: "Take a picture of your growing belly.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Apply a moisturizing body lotion to your abdomen and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes per day for stimulating your baby by singing or talking to your baby or playing soothing, calming music.",
            value: false,
          },
          {
            text: "Your breasts will be larger, so consider wearing a supportive bra.",
            value: false,
          },
          {
            text: "Do Kegel exercises to strengthen your pelvic floor and help with birth pain.",
            value: false,
          },
          {
            text: "If you are sitting in one place for too long, gently stretch your legs and arms.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "If you are planning to breastfeed, find a good lactation consultant or breastfeeding classes you can sign up for.",
            value: false,
          },
          {
            text: "Search the pros and cons of various birth methods such as water birth or hypnobirthing, and alternative birth methods if you wish.",
            value: false,
          },
          {
            text: "Join one or more pregnancy, breastfeeding and parenting groups online.",
            value: false,
          },
          {
            text: "Look for baby room or nursery designs.",
            value: false,
          },
          {
            text: "Start searching for baby names.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Plan your maternity leave with your supervisor and close colleagues.",
            value: false,
          },
          {
            text: "Find out who will take responsibility of your task in your absence.",
            value: false,
          },
          {
            text: "If you sit in one place for a long time, remember to stretch lightly from time to time.",
            value: false,
          },
          {
            text: "Start preparing your to-do list before going on maternity leave.",
            value: false,
          },
          {
            text: "Investigate childcare options if you plan to return to work.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 25,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "Your belly is the size of a soccer ball!",
            value: false,
          },
          {
            text: "You may start to experience aches and pains all over your body as well as your legs and even your waist.",
            value: false,
          },
          {
            text: "You may experience constipation.",
            value: false,
          },
          {
            text: "Your nipples will change color and become darker.",
            value: false,
          },
          {
            text: "You may experience heartburn and indigestion.",
            value: false,
          },
          {
            text: "You may experience snoring and nasal congestion due to increased pregnancy hormones.",
            value: false,
          },
          {
            text: "You may feel uncomfortable tingling, numbness or pain in your wrists and fingers (carpal tunnel syndrome).",
            value: false,
          },
          {
            text: "You may experience Braxton Hicks or false contractions.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Consume fiber-rich vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and canned foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Do some light exercises every day - a brisk walk or pregnancy yoga is great.",
            value: false,
          },
          {
            text: "Do your Kegel exercises every day.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Oral Glucose Tolerance Test (GTT) (week 24 to week 28) - to screen for gestational diabetes in the mother. It includes 3 blood tests.",
            value: false,
          },
          {
            text: "Do not miss your regular appointments with the obstetrician.",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check whether your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Look out for any unusual symptoms and report them to the doctor immediately, if any.",
            value: false,
          },
          {
            text: "Maintain good dental hygiene to reduce the risk of bleeding gums or infection.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is any risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about preterm birth risks.",
            value: false,
          },
          {
            text: "Talk to your doctor about other concerns.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Avoid bleach or other products with harsh chemicals while doing housework.",
            value: false,
          },
          {
            text: "Encourage your husband to interact with your baby.",
            value: false,
          },
          {
            text: "Listen to soothing music to help you relax.",
            value: false,
          },
          {
            text: "Avoid sleeping on your back.",
            value: false,
          },
          {
            text: "If you have ideas about your baby shower, share them with your friends who are planning it.",
            value: false,
          },
          {
            text: "Pamper yourself with a pedicure or massage.",
            value: false,
          },
          {
            text: "Keep exercising, but don`t push yourself.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Use a pregnancy pillow for better sleep.",
            value: false,
          },
          {
            text: "Use safe cosmetics that do not contain harmful chemicals.",
            value: false,
          },
          {
            text: "Take a picture of your growing belly.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Don`t forget to apply a moisturizing body lotion to your belly and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes per day for stimulating your baby by singing or talking to your baby or playing soothing, calming music.",
            value: false,
          },
          {
            text: "Your breasts will be larger so consider wearing a supportive bra.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Search for baby names.",
            value: false,
          },
          {
            text: "Do you need to employ an assistant? Start investigating the process of running one.",
            value: false,
          },
          {
            text: "Search insurance plans to cover pregnancy, childbirth and beyond.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Start thinking about who will take care of your baby when you return to work after maternity leave.",
            value: false,
          },
          {
            text: "Do you have a nursing room in your office or a place where you can express milk when you return? If not, talk to your manager about it.",
            value: false,
          },
          {
            text: "Find out what your company policies are for extending maternity leave if needed.",
            value: false,
          },
          {
            text: "Start making notes for your colleague who will take over your workload while you`re away.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You have a significant weight gain or feel extremely bloated, have strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 26,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You will feel the baby kicking and moving a lot.",
            value: false,
          },
          {
            text: "You may have trouble in sleeping due to back pain, heartburn and leg cramps.",
            value: false,
          },
          {
            text: "You will experience aches and pains all over your body.",
            value: false,
          },
          {
            text: "You may start to experience severe cramps in your legs.",
            value: false,
          },
          {
            text: "Some women may experience blurred vision caused by pregnancy hormones.",
            value: false,
          },
          {
            text: "You may experience Braxton Hicks or false contractions.",
            value: false,
          },
          {
            text: "You may be experiencing heartburn and indigestion.",
            value: false,
          },
          {
            text: "You may feel warmer and experience hot flash.",
            value: false,
          },
          {
            text: 'Feeling more forgetful lately? You may be experiencing a "pregnancy brain".',
            value: false,
          },
          {
            text: "You may be clumsy and weak due to loose joints and weight gain.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Consume fiber-rich vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and canned foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Sign up for a pregnancy yoga class if you haven`t already.",
            value: false,
          },
          {
            text: "Do your Kegels every day.",
            value: false,
          },
          {
            text: "Practice breathing techniques that will help you at birth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Oral Glucose Tolerance Test (GTT) (week 24 to week 28) - to screen for gestational diabetes in the mother. It includes 3 blood tests.",
            value: false,
          },
          {
            text: "Do not miss your regular appointments with the obstetrician.",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Look out for any unusual symptoms and report them to the doctor immediately if any.",
            value: false,
          },
          {
            text: "Maintain good dental hygiene to reduce the risk of bleeding gums or infection.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the possibility of a vaginal delivery if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about preterm birth risks.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Take amazing pregnancy photos.",
            value: false,
          },
          {
            text: "Decide on your preferred hospital for delivery - it should not be too far from your home.",
            value: false,
          },
          {
            text: "Count the baby`s kicks and movements in the morning and at night (if there is no movement all day, see your doctor).",
            value: false,
          },
          {
            text: "Avoid cleaning with heavy chemicals while doing housework.",
            value: false,
          },
          {
            text: "Encourage your husband to interact with your baby.",
            value: false,
          },
          {
            text: "Listen to soothing music to help you relax.",
            value: false,
          },
          {
            text: "Avoid sleeping on your back as it may restrict blood circulation.",
            value: false,
          },
          {
            text: "If you have ideas about your baby shower, share them with your friends who are planning it.",
            value: false,
          },
          {
            text: "Pamper yourself with a pedicure or massage.",
            value: false,
          },
          {
            text: "Keep exercising but don`t tire yourself.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Use a pregnancy pillow for better sleep.",
            value: false,
          },
          {
            text: "Use safe cosmetics that do not contain harmful chemicals.",
            value: false,
          },
          {
            text: "Take a picture of your growing belly.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Apply a moisturizing body lotion to your abdomen and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your little one by singing songs or even talking to your baby.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Search for baby names.",
            value: false,
          },
          {
            text: "Do you need to employ an assistant? Start investigating the process of running one.",
            value: false,
          },
          {
            text: "Look for insurance plans to cover both pregnancy, childbirth and beyond.",
            value: false,
          },
          {
            text: "Search and book Babymoon destinations.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Start thinking about who will take care of your baby when you return to work after maternity leave.",
            value: false,
          },
          {
            text: "Do you have a nursing room in your office or a place to pump milk when you return? If not, talk to your manager about it.",
            value: false,
          },
          {
            text: "Find out what your company policies are for extending maternity leave if needed.",
            value: false,
          },
          {
            text: "Start making notes for your colleague who will take over your workload while you`re away.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 27,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may start to feel Braxton-Hicks contractions (your uterus feels tight or oppressed when this happens)",
            value: false,
          },
          {
            text: "Your ankles, feet and hands may swell slightly due to fluid buildup in the body.",
            value: false,
          },
          {
            text: "You may experience bleeding gums.",
            value: false,
          },
          {
            text: "You will feel and even see your baby`s kicks and movements.",
            value: false,
          },
          {
            text: "Your legs may become tense and a little tingling - this is called restless legs syndrome.",
            value: false,
          },
          {
            text: "You may feel faint or dizzy.",
            value: false,
          },
          {
            text: "Your tense belly can cause your skin to be dry and itchy.",
            value: false,
          },
          {
            text: "You may experience round ligament pain caused by your enlarged uterus.",
            value: false,
          },
          {
            text: "You may experience nasal congestion due to high pregnancy hormones.",
            value: false,
          },
          {
            text: "As the uterus grows, it puts pressure on your upper chest and you may feel breathless.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Consume fiber-rich vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and canned foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Sign up for a pregnancy yoga class.",
            value: false,
          },
          {
            text: "Walking is also a good exercise.",
            value: false,
          },
          {
            text: "Practice daily Kegel exercises.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Oral Glucose Tolerance Test (GTT) (week 24 to week 28) - to screen for gestational diabetes in the mother. It includes 3 blood tests.",
            value: false,
          },
          {
            text: "Do not miss your regular appointments with the obstetrician.",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Look out for any unusual symptoms and report them to the doctor immediately, if any.",
            value: false,
          },
          {
            text: "Maintain good dental hygiene to reduce the risk of bleeding gums or infection.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about preterm birth risks.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Take pregnancy photos.",
            value: false,
          },
          {
            text: "Decide on your preferred hospital for delivery - it should not be too far from your home.",
            value: false,
          },
          {
            text: "Count the baby`s kicks and movements in the morning and at night (if there is no movement all day, see your doctor).",
            value: false,
          },
          {
            text: "Avoid cleaning with heavy chemicals while doing housework.",
            value: false,
          },
          {
            text: "Encourage your husband to interact with your baby.",
            value: false,
          },
          {
            text: "Listen to soothing music to help you relax.",
            value: false,
          },
          {
            text: "Avoid sleeping on your back as it may restrict blood circulation.",
            value: false,
          },
          {
            text: "Book your Babymoon destination.",
            value: false,
          },
          {
            text: "If you have ideas about your baby shower, share them with your friends who are planning it.",
            value: false,
          },
          {
            text: "Pamper yourself with a pedicure or massage.",
            value: false,
          },
          {
            text: "Keep exercising but don`t tire yourself.",
            value: false,
          },
          {
            text: "Start saving and investing in your child`s future.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Use a pregnancy pillow for better sleep.",
            value: false,
          },
          {
            text: "Use safe cosmetics that do not contain harmful chemicals.",
            value: false,
          },
          {
            text: "Take a picture of your growing belly.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Don`t forget to apply a moisturizing body lotion to your belly and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day stimulating your little one by singing songs or even talking to your baby.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Get information about cord blood and make your decision.",
            value: false,
          },
          {
            text: "Learn about your baby`s development.",
            value: false,
          },
          {
            text: "Search and join an online mom community.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Do you have a nursing room in your office or a place where you can express milk when you return? If not, talk to your manager about it.",
            value: false,
          },
          {
            text: "Find out what your company policies are for extending maternity leave if needed.",
            value: false,
          },
          {
            text: "Start preparing notes for your colleague who will take over your workload while you`re away.",
            value: false,
          },
          {
            text: "Write down your daily tasks as pregnancy can make you forget.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal dischargez",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions",
            value: false,
          },
          {
            text: "There is a sharp decrease in fetal movement",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 28,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may still be experiencing inflammation, swelling or bleeding from the gums.",
            value: false,
          },
          {
            text: "You may experience leg cramps.",
            value: false,
          },
          {
            text: "You may have hemorrhoids.",
            value: false,
          },
          {
            text: "It can be difficult to fall asleep with the big belly and baby kicks.",
            value: false,
          },
          {
            text: "Constipation will be more frequent as the pressure in the colon increases.",
            value: false,
          },
          {
            text: "You may experience anxiety about childbirth.",
            value: false,
          },
          {
            text: "Your nipples will become larger and darker.",
            value: false,
          },
          {
            text: "You may have a dark line running from your navel to your pubic bone: the linea nigra.",
            value: false,
          },
          {
            text: "Your tense abdomen can cause your skin to be dry and itchy.",
            value: false,
          },
          {
            text: "You may feel extremely tired.",
            value: false,
          },
          {
            text: "You may experience bloating and gas.",
            value: false,
          },
          {
            text: "Your nose may be stuffy.",
            value: false,
          },
          {
            text: "Sometimes you may feel out of breath.",
            value: false,
          },
          {
            text: "You may experience Braxton Hicks or false contractions.",
            value: false,
          },
          {
            text: "You may have pain in your pelvic area and lower back.",
            value: false,
          },
          {
            text: "You may experience frequent urination.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Always prepare healthy snacks.",
            value: false,
          },
          {
            text: "Drink at least 10-12 glasses of water every day to stay hydrated and prevent constipation.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Start your day with light exercise such as walking or stretching.",
            value: false,
          },
          {
            text: "You can also try pregnancy yoga.",
            value: false,
          },
          {
            text: "Practice Kegel exercises to assist you in birth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Oral Glucose Tolerance Test (GTT) (week 24 to week 28) - to screen for gestational diabetes in the mother. It includes 3 blood tests.",
            value: false,
          },
          {
            text: "If you are Rh negative, you may need an injection known as an anti-D injection.",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Watch the baby kicks. You should feel 10 kicks, movement within 2 hours.",
            value: false,
          },
          {
            text: "Look out for any unusual symptoms and report them to the doctor immediately if any.",
            value: false,
          },
          {
            text: "Maintain good dental hygiene to reduce the risk of bleeding gums or infection.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask about 3D or 4D scanning.",
            value: false,
          },
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal birth if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about preterm birth risks.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Get enough rest each day and take a nap if necessary.",
            value: false,
          },
          {
            text: "Take a photo shoot for pregnancy.",
            value: false,
          },
          {
            text: "Start shopping for your baby - don`t buy too many newborn clothes as your baby will grow quickly.",
            value: false,
          },
          {
            text: "Choose a name for your baby or make a list.",
            value: false,
          },
          {
            text: "Encourage your husband to interact with your baby.",
            value: false,
          },
          {
            text: "Listen to soothing music to help you relax.",
            value: false,
          },
          {
            text: "Avoid sleeping on your back as it may restrict blood circulation.",
            value: false,
          },
          {
            text: "If you have ideas about your baby shower, share them with your friends who are planning it.",
            value: false,
          },
          {
            text: "Pamper yourself with a pedicure or massage.",
            value: false,
          },
          {
            text: "Keep exercising but don`t tire yourself.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Use a pregnancy pillow for better sleep.",
            value: false,
          },
          {
            text: "Use safe cosmetics that do not contain harmful chemicals.",
            value: false,
          },
          {
            text: "Take a picture of your growing belly.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Don`t forget to apply a moisturizing body lotion to your belly and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day stimulating your little one by singing songs or even talking to your baby.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about storing your baby`s cord blood.",
            value: false,
          },
          {
            text: "Enroll in a birth or breastfeeding course.",
            value: false,
          },
          {
            text: "Investigate childcare options if you need to return to work soon.",
            value: false,
          },
          {
            text: "Do search for car seats.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Do you have a nursing room in your office or a place where you can express milk when you return? If not, talk to your manager about it.",
            value: false,
          },
          {
            text: "Find out what your company policies are for extending maternity leave if needed.",
            value: false,
          },
          {
            text: "Start preparing notes for your colleague who will take over your workload while you`re away.",
            value: false,
          },
          {
            text: "Write down your daily tasks as pregnancy can make you forget.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if …",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
          {
            text: "There is a sharp decrease in fetal movement.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 29,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "Your baby can kick and punch vigorously.",
            value: false,
          },
          {
            text: "Even if you have just eaten, you may feel hungry very quickly.",
            value: false,
          },
          {
            text: "You may experience rashes, dry skin and intense itching.",
            value: false,
          },
          {
            text: "You may experience mood swings.",
            value: false,
          },
          {
            text: "You may have constipation and hemorrhoids.",
            value: false,
          },
          {
            text: "You may have varicose veins, which are swollen and possibly itchy blue veins on your legs.",
            value: false,
          },
          {
            text: "You may experience leg cramps.",
            value: false,
          },
          {
            text: "You may have difficulty breathing because the enlarged uterus puts pressure on your lungs.",
            value: false,
          },
          {
            text: "You may see mild swelling, known as edema, in your ankles, feet, and hands.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Eat foods rich in iron to help increase red blood cell production.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Try doing some light exercise in the morning to lighten up for relieving back pain, low back pain, etc.",
            value: false,
          },
          {
            text: "You can also try pregnancy yoga.",
            value: false,
          },
          {
            text: "Practice Kegel exercises to assist you in birth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "If you feel unusually sad, anxious or depressed, consult your doctor.",
            value: false,
          },
          {
            text: "How about an ultrasound to check your baby`s development, position and record the fetal heartbeat!",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "If you have varicose veins, talk to your doctor about how to manage them.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about preterm birth risks.",
            value: false,
          },
          {
            text: "Ask about 3D or 4D scanning.",
            value: false,
          },
          {
            text: "Talk to your doctor about other concerns.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Avoid scratching your skin if you feel itchy; apply a good moisturizer instead.",
            value: false,
          },
          {
            text: "Get enough rest each day - take a nap if necessary.",
            value: false,
          },
          {
            text: "Start shopping for your baby; don`t buy too many newborn clothes, they grow up fast.",
            value: false,
          },
          {
            text: "Take your weekly photo.",
            value: false,
          },
          {
            text: "Choose a name for your baby or make a list.",
            value: false,
          },
          {
            text: "Encourage your partner to interact with your baby.",
            value: false,
          },
          {
            text: "Listen to soothing music to help you relax.",
            value: false,
          },
          {
            text: "Avoid sleeping on your back as it may restrict blood circulation. Sleep on your left side.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "If you have ideas about your baby shower, share them with your friends who are planning it.",
            value: false,
          },
          {
            text: "Pamper yourself with a pedicure or massage.",
            value: false,
          },
          {
            text: "Keep exercising but don`t tire yourself.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Use a pregnancy pillow for better sleep.",
            value: false,
          },
          {
            text: "Use safe cosmetics that do not contain harmful chemicals.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your little one by singing songs or even talking to your baby.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Enroll in a birth or breastfeeding course.",
            value: false,
          },
          {
            text: "Start researching postpartum massage treatments.",
            value: false,
          },
          {
            text: "Learn about storing your baby`s cord blood.",
            value: false,
          },
          {
            text: "Investigate childcare options if you need to return to work soon.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Confirm when your maternity leave will start and talk to your manager.",
            value: false,
          },
          {
            text: "Find out what your company policies are for extending maternity leave if needed.",
            value: false,
          },
          {
            text: "Start preparing notes for your colleague who will take over your workload while you`re away.",
            value: false,
          },
          {
            text: "Write down your daily tasks as pregnancy can make you forget.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if …",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
          {
            text: "There is a sharp decrease in fetal movement.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 30,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may experience heartburn.",
            value: false,
          },
          {
            text: "You will see your stomach move and fluctuate as your baby moves and kicks.",
            value: false,
          },
          {
            text: "You may experience mood swings and fatigue.",
            value: false,
          },
          {
            text: "Your balance may be impaired while your joints are stretched.",
            value: false,
          },
          {
            text: "Your ligament slackening can cause your feet to expand permanently and increase one size.",
            value: false,
          },
          {
            text: "You may feel low back pain.",
            value: false,
          },
          {
            text: "You may experience cracks.",
            value: false,
          },
          {
            text: "You may be suffering from bloating, gas and/or constipation.",
            value: false,
          },
          {
            text: "You may experience frequent urination.",
            value: false,
          },
          {
            text: "You may have difficulty in breathing.",
            value: false,
          },
          {
            text: "You may experience Braxton Hicks contractions.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Eat foods rich in iron to help increase red blood cell production.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Incorporate exercise into your daily routine.",
            value: false,
          },
          {
            text: "You can also try pregnancy yoga.",
            value: false,
          },
          {
            text: "Practice your Kegel exercises to assist you in birth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "If you are feeling unusually sad, anxious or depressed, please see your doctor without delay.",
            value: false,
          },
          {
            text: "How about an ultrasound to check your baby`s development, position and record the fetal heartbeat!",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal birth if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "If you have varicose veins, talk to your doctor about how to manage them.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about preterm birth risks.",
            value: false,
          },
          {
            text: "Ask about 3D or 4D scanning.",
            value: false,
          },
          {
            text: "Talk to your doctor about other concerns.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Monitor your posture to manage lower back pain.",
            value: false,
          },
          {
            text: "Rest and relax as much as possible.",
            value: false,
          },
          {
            text: "Don`t forget to apply a moisturizing body lotion to your belly and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Sleep on your left side to improve blood circulation.",
            value: false,
          },
          {
            text: "Prepare baby name lists.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly!",
            value: false,
          },
          {
            text: "Pamper yourself with a pedicure or massage.",
            value: false,
          },
          {
            text: "Keep exercising but don`t tire yourself.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Use a pregnancy pillow for better sleep.",
            value: false,
          },
          {
            text: "Use safe cosmetics that do not contain harmful chemicals.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your little one by singing songs or even talking to your baby.",
            value: false,
          },
          {
            text: "Set a date for your baby shower.",
            value: false,
          },
          {
            text: "Do not skip breastfeeding or birth preparation courses.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Start searching postpartum massage treatments.",
            value: false,
          },
          {
            text: "Learn and be prepared for your chosen delivery method.",
            value: false,
          },
          {
            text: "Make a birth plan.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Fill in all the paperwork you need to complete before going on maternity leave.",
            value: false,
          },
          {
            text: "Start preparing notes for your colleague who will take over your workload while you`re away.",
            value: false,
          },
          {
            text: "Write down your daily tasks as pregnancy can make you forget.",
            value: false,
          },
          {
            text: "Bring healthy snacks and keep a bottle of water at your desk.",
            value: false,
          },
          {
            text: "If you need to return to work soon and you don`t have a helper or caregiver to care for your baby, start exploring daycare options.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
          {
            text: "There is a sharp decrease in fetal movement.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 31,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You will need to urinate frequently because your uterus is pressing down heavily on your bladder.",
            value: false,
          },
          {
            text: "You may experience a headache.",
            value: false,
          },
          {
            text: 'You may experience "pregnancy brain" that causes you becoming forgetful (don`t worry, everything will be back to normal after giving birth).',
            value: false,
          },
          {
            text: "Your softener bonds can make you clumsy, so watch your steps!",
            value: false,
          },
          {
            text: "You may have back pain.",
            value: false,
          },
          {
            text: "You may have difficulty in breathing.",
            value: false,
          },
          {
            text: "You may be having trouble in sleeping.",
            value: false,
          },
          {
            text: "You may also experience itching in your abdomen, breasts and/or buttocks.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Make sure you have an iron-rich food intake to help increase red blood cell production.",
            value: false,
          },
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Walk for a while or do some light exercise to improve your circulation.",
            value: false,
          },
          {
            text: "Practice Kegel exercises to strengthen your pelvic muscles for childbirth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "If you feel unusually sad, anxious or depressed, consult your doctor.",
            value: false,
          },
          {
            text: "Get an ultrasound to check your baby`s development, position, and record the fetal heartbeat.",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about preterm birth risks.",
            value: false,
          },
          {
            text: "Ask the difference between fake and real birth pains.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Be careful when walking on slippery road and uneven surfaces.",
            value: false,
          },
          {
            text: "Place a non-slip mat in your shower area to prevent falls.",
            value: false,
          },
          {
            text: "Start collecting your birth bag.",
            value: false,
          },
          {
            text: "When your skin is itchy, apply a moisturizer instead of scratching it.",
            value: false,
          },
          {
            text: "Sleep on your left side to improve blood circulation.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly.",
            value: false,
          },
          {
            text: "Pamper yourself with a pedicure or massage.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your baby by singing songs or even talking to your baby.",
            value: false,
          },
          {
            text: "Start saving and investing in your child`s future.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Use a pregnancy pillow for better sleep.",
            value: false,
          },
          {
            text: "Use safe cosmetics that do not contain harmful chemicals.",
            value: false,
          },
          {
            text: "Do not skip breastfeeding or birth preparation courses.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Don`t forget to apply a moisturizing body lotion to your abdomen and other areas to prevent stretch marks.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "What You Should Have in Your Hospital Bag",
        checklists: [
          {
            text: "Toiletries, slippers and socks, make-up products, toothbrush, moisturizer, lip balm, deodorant, hair bands, etc. personal equipment",
            value: false,
          },
          {
            text: "Your birth plan",
            value: false,
          },
          {
            text: "Breast pump when you need to express milk",
            value: false,
          },
          {
            text: "At least 3 sets of newborn clothing - avoid complex clothing, cotton bodysuits that cover the arms and legs are best.",
            value: false,
          },
          {
            text: "Items to help you relax like comfortable pillows, a playlist of your favorite songs, snacks, etc.",
            value: false,
          },
          {
            text: "Loose, comfortable clothes",
            value: false,
          },
          {
            text: "Important documents such as identity cards, insurance documents, etc. ",
            value: false,
          },
          {
            text: "Phone and phone charger",
            value: false,
          },
          {
            text: "Baby`s homecoming outfit (including socks or booties and blanket)",
            value: false,
          },
          {
            text: "Sanitary pads for the mother",
            value: false,
          },
          {
            text: "Diapers",
            value: false,
          },
          {
            text: "Wet wipes, a gentle baby wash and other baby supplies.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about your baby`s development this week.",
            value: false,
          },
          {
            text: "Search on newborn care and your own care",
            value: false,
          },
          {
            text: "Learn and be prepared for your chosen delivery method.",
            value: false,
          },
          {
            text: "Look for signs of preterm birth.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Fill in all the paperwork you need to complete before going on maternity leave.",
            value: false,
          },
          {
            text: "Start preparing notes for your colleague who will take over your workload while you`re away.",
            value: false,
          },
          {
            text: "Write down your daily tasks as pregnancy can make you forget.",
            value: false,
          },
          {
            text: "Bring healthy snacks to work and keep a bottle of water at your desk.",
            value: false,
          },
          {
            text: "If you need to return to work soon and you don`t have a helper or caregiver to care for your baby, start exploring daycare options.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever greater than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or stiff",
            value: false,
          },
          {
            text: "There is stomach ache",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "There is a sharp decrease in fetal movement",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 32,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You should be prepared for Braxton Hicks or false contractions.",
            value: false,
          },
          {
            text: "You may notice clear or yellowish drops of fluid coming out of your nipples; this is colostrum and it will be your baby`s first milk.",
            value: false,
          },
          {
            text: "Your cracks and linea nigra are more apparent.",
            value: false,
          },
          {
            text: "You will start to feel much more tired.",
            value: false,
          },
          {
            text: "You may experience painful leg cramps.",
            value: false,
          },
          {
            text: "You may have constipation and hemorrhoids.",
            value: false,
          },
          {
            text: "You may have difficulty in breathing because the enlarged uterus puts pressure on your lungs.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Drink 10-12 glasses of water a day.",
            value: false,
          },
          {
            text: "Eat protein and carbohydrate-rich snacks to give you energy and combat fatigue.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Make sure you get enough calcium and vitamin D to help absorb the calcium.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Prenatal yoga is not only good exercise, it can also help relieve body aches and pains.",
            value: false,
          },
          {
            text: "Walk for a while or do some light exercise to improve your circulation.",
            value: false,
          },
          {
            text: "Practice Kegel exercises to strengthen your pelvic muscles for childbirth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "How about an ultrasound to check your baby`s development, position and record the fetal heartbeat!",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Consult your doctor if you feel unusually sad, anxious or depressed.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is any risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about preterm birth risks.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Try calamine lotion to soothe itchy skin.",
            value: false,
          },
          {
            text: "It`s time for your baby shower!",
            value: false,
          },
          {
            text: "Prepare your delivery bag.",
            value: false,
          },
          {
            text: "Visit the hospital of your choice and see its facilities.",
            value: false,
          },
          {
            text: "Sleep on your side and use a pregnancy pillow for extra comfort.",
            value: false,
          },
          {
            text: "Start shopping for baby - don`t buy too many newborn clothes as your baby will grow too fast.",
            value: false,
          },
          {
            text: "Get enough rest throughout the day and take a nap if necessary.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly.",
            value: false,
          },
          {
            text: "Decide on your little one`s name.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Ask your husband to talk to your baby.",
            value: false,
          },
          {
            text: "Finish decorating your baby`s room.",
            value: false,
          },
          {
            text: "Start saving and investing in your child`s future.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Choose cosmetics that are safe for pregnant women.",
            value: false,
          },
          {
            text: "Don`t forget to apply a moisturizing body lotion to your belly and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your little one by singing songs or even talking to your baby.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "What You Should Have in Your Hospital Bag",
        checklists: [
          {
            text: "Toiletries, slippers and socks, make-up products, toothbrush, moisturizer, lip balm, deodorant, hair bands, etc.",
            value: false,
          },
          {
            text: "Your birth plan",
            value: false,
          },
          {
            text: "Breast pump when you need to express milk",
            value: false,
          },
          {
            text: "At least 3 sets of newborn clothing - avoid complex clothing, cotton bodysuits that cover arms and legs are best",
            value: false,
          },
          {
            text: "Items to help you relax like comfortable pillows, a playlist of your favorite songs, snacks, etc. ",
            value: false,
          },
          {
            text: "Loose, comfortable clothes to wear",
            value: false,
          },
          {
            text: "Important documents such as identity cards, insurance documents, etc. ",
            value: false,
          },
          {
            text: "Phone and phone charger",
            value: false,
          },
          {
            text: "Baby`s homecoming outfit (including socks or booties and blanket)",
            value: false,
          },
          {
            text: "Sanitary pads for the mother",
            value: false,
          },
          {
            text: "Diapers",
            value: false,
          },
          {
            text: "Wet wipes, a gentle baby wash and other baby supplies.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Search different breastfeeding grips and learn how to hold your baby correctly.",
            value: false,
          },
          {
            text: "Learn how to manage labor with breathing and other techniques.",
            value: false,
          },
          {
            text: "Do research on postpartum depression and know the symptoms.",
            value: false,
          },
          {
            text: "Learn about the procedures you will encounter during childbirth.",
            value: false,
          },
          {
            text: "Search breast pumps.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Fill in all the paperwork you need to complete before going on maternity leave.",
            value: false,
          },
          {
            text: "Start preparing notes for your colleague who will take over your workload while you`re away.",
            value: false,
          },
          {
            text: "Write down your daily tasks as pregnancy can make you forget.",
            value: false,
          },
          {
            text: "Bring healthy snacks to work and keep a bottle of water at your desk.",
            value: false,
          },
          {
            text: "If you need to return to work soon and you don`t have a helper or caregiver to care for your baby, start exploring daycare options.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever greater than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "There is stomach ache",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "There is a sharp decrease in fetal movement",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 33,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may feel hot all the time.",
            value: false,
          },
          {
            text: "You may have trouble in sleeping.",
            value: false,
          },
          {
            text: "You will need to urinate frequently and you will experience leg cramps and heartburn.",
            value: false,
          },
          {
            text: "You may experience frequent headaches and anxiety.",
            value: false,
          },
          {
            text: "Your nails may become brittle.",
            value: false,
          },
          {
            text: "You may feel pain in the abdomen due to stretching and loosening of your ligaments while changing position in bed.",
            value: false,
          },
          {
            text: "You may experience shortness of breath as your uterus pushes against your lungs.",
            value: false,
          },
          {
            text: "You may be more careless and forgetful.",
            value: false,
          },
          {
            text: "Your breasts may leak a yellowish liquid called colostrum.",
            value: false,
          },
          {
            text: "You may experience Braxton Hicks or false contractions.",
            value: false,
          },
          {
            text: "You may be more clumsy.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Avoid eating just before going to sleep to prevent heartburn.",
            value: false,
          },
          {
            text: "Continue to consume healthy foods.",
            value: false,
          },
          {
            text: "Drink at least 10-12 glasses of water every day.",
            value: false,
          },
          {
            text: "Avoid drinking carbonated beverages.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Avoid strenuous exercise; walking is good.",
            value: false,
          },
          {
            text: "Try prenatal yoga to relieve body aches.",
            value: false,
          },
          {
            text: "Practice Kegel exercises to strengthen your pelvic muscles for childbirth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "If you feel unusually sad, anxious or depressed, consult your doctor.",
            value: false,
          },
          {
            text: "How about an ultrasound to check your baby`s development, position and record the fetal heartbeat!",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about preterm birth risks.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Indulge yourself in a warm bubble bath to relieve fatigue.",
            value: false,
          },
          {
            text: "Listen to your favorite relaxing songs before going to bed.",
            value: false,
          },
          {
            text: "If you plan to retain your placenta after delivery, sign up for the encapsulation process this week.",
            value: false,
          },
          {
            text: "Try calamine lotion to soothe itchy skin.",
            value: false,
          },
          {
            text: "It`s time for your baby shower!",
            value: false,
          },
          {
            text: "Prepare your delivery bag.",
            value: false,
          },
          {
            text: "Visit the hospital of your choice and see its facilities.",
            value: false,
          },
          {
            text: "Sleep on your side and use a pregnancy pillow for extra comfort.",
            value: false,
          },
          {
            text: "Start shopping for baby - don`t buy too many newborn clothes as your baby will grow too fast.",
            value: false,
          },
          {
            text: "Get enough rest throughout the day and take a nap if necessary.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly.",
            value: false,
          },
          {
            text: "Decide on your little one`s name.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Ask your husband to talk to your baby.",
            value: false,
          },
          {
            text: "Finish decorating your baby`s room.",
            value: false,
          },
          {
            text: "Start saving and investing in your child`s future.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Choose cosmetics that are safe for pregnant women.",
            value: false,
          },
          {
            text: "Don`t forget to apply a moisturizing body lotion to belly and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your little one by singing songs or even talking to your baby.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "What You Should Have in Your Hospital Bag",
        checklists: [
          {
            text: "Toiletries, slippers and socks, make-up products, toothbrush, moisturizer, lip balm, deodorant, hair bands, etc.",
            value: false,
          },
          {
            text: "Your birth plan",
            value: false,
          },
          {
            text: "Breast pump when you need to express milk",
            value: false,
          },
          {
            text: "At least 3 sets of newborn clothing - avoid complex clothing, cotton bodysuits that cover arms and legs are best",
            value: false,
          },
          {
            text: "Items to help you relax like comfortable pillows, a playlist of your favorite songs, snacks, etc. ",
            value: false,
          },
          {
            text: "Loose, comfortable clothes to wear",
            value: false,
          },
          {
            text: "Important documents such as identity cards, insurance documents, etc. ",
            value: false,
          },
          {
            text: "Phone and phone charger",
            value: false,
          },
          {
            text: "Baby`s homecoming outfit (including socks or booties and blanket)",
            value: false,
          },
          {
            text: "Sanitary pads for the mother",
            value: false,
          },
          {
            text: "Diapers",
            value: false,
          },
          {
            text: "Wet wipes, a gentle baby wash and other baby supplies.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Keep reading about birth and birth.",
            value: false,
          },
          {
            text: "Learn about pain relief and epidurals during birth.",
            value: false,
          },
          {
            text: "Learn about baby care and parenting.",
            value: false,
          },
          {
            text: "Read and prepare for your birth method.",
            value: false,
          },
          {
            text: "Learn about signs of birth or preterm labor such as rupture of amniotic fluid, menstrual-like cramps, vaginal bleeding and more.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Fill in all the paperwork you need to complete before going on maternity leave.",
            value: false,
          },
          {
            text: "Start preparing notes for your colleague who will take over your workload while you`re away.",
            value: false,
          },
          {
            text: "Write down your daily tasks as pregnancy can make you forget.",
            value: false,
          },
          {
            text: "Bring healthy snacks and keep a bottle of water at your desk.",
            value: false,
          },
          {
            text: "If you need to return to work soon and you don`t have a helper or caregiver to care for your baby, start exploring daycare options.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever greater than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or stiff",
            value: false,
          },
          {
            text: "There is stomach ache",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "There is a sharp decrease in fetal movement",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 34,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may feel more tired than usual.",
            value: false,
          },
          {
            text: "You may notice an increase in vaginal fluids.",
            value: false,
          },
          {
            text: "You may experience dizziness.",
            value: false,
          },
          {
            text: "You may urinate frequently.",
            value: false,
          },
          {
            text: "You may feel breathless as your uterus pushes against your lungs.",
            value: false,
          },
          {
            text: "You may notice colostrum leaking from your breasts.",
            value: false,
          },
          {
            text: "Your feet and ankles may swell.",
            value: false,
          },
          {
            text: "You may experience (temporary) blurred vision.",
            value: false,
          },
          {
            text: "You may have stretch marks on your abdomen or chest that may appear as pink, red, purple, reddish brown, or dark brown streaks.",
            value: false,
          },
          {
            text: "You may experience bloating and gas.",
            value: false,
          },
          {
            text: "You may have constipation and hemorrhoids.",
            value: false,
          },
          {
            text: "You may have back pain due to the tension caused by your growing belly.",
            value: false,
          },
          {
            text: "You may have trouble in sleeping.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Avoid eating just before going to sleep to prevent heartburn.",
            value: false,
          },
          {
            text: "Continue to consume healthy foods.",
            value: false,
          },
          {
            text: "Drink at least 10-12 glasses of water every day.",
            value: false,
          },
          {
            text: "Avoid drinking carbonated beverages.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Eat protein and carbohydrate-rich snacks to give you energy and combat fatigue.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Do light exercises such as walking (don`t forget to carry a bottle of water with you!).",
            value: false,
          },
          {
            text: "Continue prenatal yoga.",
            value: false,
          },
          {
            text: "Keep practicing your Kegel exercises.",
            value: false,
          },
          {
            text: "Avoid strenuous exercise.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "If you feel unusually sad, anxious or depressed, consult your doctor.",
            value: false,
          },
          {
            text: "How about an ultrasound to check your baby`s development, position and record the fetal heartbeat!",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Watch out for signs of preterm birth such as bloody discharge from your vagina.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal birth if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "If you plan to retain your placenta after delivery, be sure to sign up for the encapsulation process this week.",
            value: false,
          },
          {
            text: "Try calamine lotion to soothe itchy skin.",
            value: false,
          },
          {
            text: "If you have severe back pain, wear a belly support belt.",
            value: false,
          },
          {
            text: "Prepare your birth bag.",
            value: false,
          },
          {
            text: "Visit the hospital of your choice and see its facilities.",
            value: false,
          },
          {
            text: "Sleep on your side and use a pregnancy pillow for extra comfort.",
            value: false,
          },
          {
            text: "Purchase your baby`s cot / bassinet and car seat.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly.",
            value: false,
          },
          {
            text: "Decide on your little one`s name.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Ask your partner to talk to your baby.",
            value: false,
          },
          {
            text: "Make sure your infant car seat is fitted correctly.",
            value: false,
          },
          {
            text: "Start saving and investing in your child`s future.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Choose cosmetics that are safe for pregnant women.",
            value: false,
          },
          {
            text: "Apply a moisturizing body lotion to your abdomen and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your little one by singing songs or even talking to your baby.",
            value: false,
          },
          {
            text: "If you experience leg cramps outside, find a place to sit and then flex your toes towards your body.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "What You Should Have in Your Hospital Bag",
        checklists: [
          {
            text: "Toiletries, slippers and socks, make-up materials, toothbrush, moisturizer, lip balm, deodorant, hair bands, etc.",
            value: false,
          },
          {
            text: "Your birth plan",
            value: false,
          },
          {
            text: "Breast pump when you need to express milk",
            value: false,
          },
          {
            text: "At least 3 sets of newborn clothing (avoid complicated clothing; cotton bodysuits to cover arms and legs are best)",
            value: false,
          },
          {
            text: "Put on comfortable clothes and nursing bras for 3 days. Pack also polyethylene bags (for your dirty laundry)",
            value: false,
          },
          {
            text: "Items to help you relax like comfortable pillows, favorite songs list, snacks etc. ",
            value: false,
          },
          {
            text: "Important documents such as identity cards, insurance documents, etc. ",
            value: false,
          },
          {
            text: "Phone and phone charger",
            value: false,
          },
          {
            text: "Baby`s homecoming outfit (plus socks or booties and blankets included)",
            value: false,
          },
          {
            text: "Sanitary pads for the mother",
            value: false,
          },
          {
            text: "Diapers",
            value: false,
          },
          {
            text: "Wet wipes, a gentle baby wash and other baby supplies.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Keep reading and learning about birth.",
            value: false,
          },
          {
            text: "Learn about pain relief options and epidurals during birth.",
            value: false,
          },
          {
            text: "Learn about baby care and parenting.",
            value: false,
          },
          {
            text: "Read and be prepared for your delivery method.",
            value: false,
          },
          {
            text: "Learn about signs of birth or preterm birth such as amniotic fluid rupture, menstrual-like cramps, vaginal bleeding, and more.",
            value: false,
          },
          {
            text: "Learn about the vaccines and tests your newborn should have right after birth.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "If you have to sit for long hours at work, try sitting on an exercise ball for short periods of time instead of on your chair.",
            value: false,
          },
          {
            text: "Fill in all the paperwork you need to complete before going on maternity leave.",
            value: false,
          },
          {
            text: "Write down your daily tasks as pregnancy may make you forget.",
            value: false,
          },
          {
            text: "Make sure you drink enough water while at work.",
            value: false,
          },
          {
            text: "Does your office have a breastfeeding/milking room? If not, talk to your manager about organizing one.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You have a fever greater than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or stiff",
            value: false,
          },
          {
            text: "There is stomach ache",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "There is a sharp decrease in fetal movement",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 35,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "Your breasts may leak a yellowish liquid called colostrum, which is your baby`s first milk.",
            value: false,
          },
          {
            text: "You may experience more frequent heartburn and gastrointestinal problems.",
            value: false,
          },
          {
            text: "You will likely feel mild contractions or Braxton Hicks contractions.",
            value: false,
          },
          {
            text: "You may have trouble controlling your bladder when coughing, sneezing or laughing.",
            value: false,
          },
          {
            text: "You may experience frequent headaches.",
            value: false,
          },
          {
            text: "Your gums may bleed.",
            value: false,
          },
          {
            text: "You may feel incompetent.",
            value: false,
          },
          {
            text: "You may have varicose veins.",
            value: false,
          },
          {
            text: "You may have hemorrhoids.",
            value: false,
          },
          {
            text: "You may experience forgetfulness.",
            value: false,
          },
          {
            text: "You may have difficulty in breathing because the enlarged uterus puts pressure on your lungs.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Avoid eating just before going to sleep to prevent heartburn.",
            value: false,
          },
          {
            text: "Continue to consume healthy foods.",
            value: false,
          },
          {
            text: "Drink at least 10-12 glasses of water every day.",
            value: false,
          },
          {
            text: "Avoid drinking carbonated beverages.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Eat protein and carbohydrate rich snacks to give you energy and combat fatigue.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Do your Kegel exercise several times each day to strengthen your pelvic muscles for labor.",
            value: false,
          },
          {
            text: "Continue light exercise such as walking.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Have Group B streptococcus screening test (between week 35 to week 37) ",
            value: false,
          },
          {
            text: "How about an ultrasound to check your baby`s development, position and record the fetal heartbeat!",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Watch out for signs of preterm birth, such as bloody discharge from your vagina.",
            value: false,
          },
          {
            text: "Consult your doctor if you feel unusually sad, anxious or depressed.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is any risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is correct.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal birth if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Wash, fold and place all your baby`s clothes.",
            value: false,
          },
          {
            text: "Write down any important phone numbers you may need when you start birth.",
            value: false,
          },
          {
            text: "Practice installing the car seat correctly.",
            value: false,
          },
          {
            text: "Your birth bag should be ready.",
            value: false,
          },
          {
            text: "Sleep on your side and use a pregnancy pillow for extra comfort.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Choose cosmetics that are safe for pregnant women.",
            value: false,
          },
          {
            text: "Apply a moisturizing body lotion to your abdomen and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your child by singing songs or even talking to your baby.",
            value: false,
          },
          {
            text: "If you experience leg cramps outside and in, find a place to sit and then flex your toes towards your body.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "What You Should Have in Your Birth Bag",
        checklists: [
          {
            text: "Toiletries, slippers and socks, make-up materials, toothbrush, moisturizer, lip balm, deodorant, hair bands, etc.",
            value: false,
          },
          {
            text: "Your birth plan",
            value: false,
          },
          {
            text: "Breast pump when you need to express milk",
            value: false,
          },
          {
            text: "At least 3 sets of newborn clothing (avoid complicated clothing; cotton baby suits to cover arms and legs are best)",
            value: false,
          },
          {
            text: "Comfortable and loose clothing for 3 days and a nursing bra. Pack also polyethylene bags (for your dirty laundry)",
            value: false,
          },
          {
            text: "Items to help you relax like comfortable pillows, favorite songs list, snacks etc. ",
            value: false,
          },
          {
            text: "Important documents such as identity cards, insurance documents, etc. ",
            value: false,
          },
          {
            text: "Phone and phone charger",
            value: false,
          },
          {
            text: "Baby`s homecoming outfit (including socks or booties and blanket)",
            value: false,
          },
          {
            text: "Sanitary pads for the mother",
            value: false,
          },
          {
            text: "Diapers",
            value: false,
          },
          {
            text: "Wet wipes, a gentle baby wash and other baby supplies.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about the procedures you will encounter during a normal or cesarean delivery.",
            value: false,
          },
          {
            text: "Book a birth photographer if you wish.",
            value: false,
          },
          {
            text: "If you don`t want artificial pain relief, read about breathing techniques during birth.",
            value: false,
          },
          {
            text: "Learn about signs of birth or preterm birth such as amniotic fluid rupture, menstrual-like cramps, vaginal bleeding, and more.",
            value: false,
          },
          {
            text: "Learn about the vaccines and tests your newborn should have right after birth.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Make plans for who will look after your baby when you return to work.",
            value: false,
          },
          {
            text: "If you have to sit for long hours at work, try sitting on an exercise ball for short periods of time instead of on your chair.",
            value: false,
          },
          {
            text: "Fill in all the paperwork you need to complete before going on maternity leave.",
            value: false,
          },
          {
            text: "Write down your daily tasks as pregnancy can make you forget.",
            value: false,
          },
          {
            text: "Make sure you drink enough water while at work.",
            value: false,
          },
          {
            text: "Does your office have a breastfeeding/milking room? If not, talk to your manager about organizing one.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You have a fever greater than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or stiff",
            value: false,
          },
          {
            text: "There is stomach ache",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "There is a sharp decrease in fetal movement",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 36,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: 'You can start "nesting", which is the urge to tidy up and organize your home and your baby`s room.',
            value: false,
          },
          {
            text: "Your back pain may get worse.",
            value: false,
          },
          {
            text: "Your vaginal discharge will be intense.",
            value: false,
          },
          {
            text: "Your lower belly will probably feel heavier as your baby has probably turned by now.",
            value: false,
          },
          {
            text: "Walking may be difficult, you may feel pelvic pain.",
            value: false,
          },
          {
            text: "You will feel Braxton Hicks contractions more often.",
            value: false,
          },
          {
            text: "You may experience bloating and gas.",
            value: false,
          },
          {
            text: "You will need to go to the bathroom frequently.",
            value: false,
          },
          {
            text: "Your feet and ankles may swell.",
            value: false,
          },
          {
            text: "You may suffer from heartburn and indigestion.",
            value: false,
          },
          {
            text: "Your breasts may leak a yellowish fluid called colostrum.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Continue to consume healthy foods.",
            value: false,
          },
          {
            text: "Drink at least 10-12 glasses of water every day.",
            value: false,
          },
          {
            text: "Avoid drinking carbonated beverages.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Eat protein and carbohydrate-rich snacks to give you energy and combat fatigue.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Do pelvic exercises to reduce pain.",
            value: false,
          },
          {
            text: "Practice Kegel exercises that will strengthen your pelvic muscles for childbirth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Have a Group B streptococcus screening test (between 35th and 37th weeks)",
            value: false,
          },
          {
            text: "How about an ultrasound to check your baby`s development, position and record the fetal heartbeat!",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Watch out for signs of preterm birth such as bloody discharge from your vagina",
            value: false,
          },
          {
            text: "Consult your doctor if you feel unusually sad, anxious or depressed.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Travel by plane is not recommended at this stage of pregnancy.",
            value: false,
          },
          {
            text: "A warm bath helps relieve pelvic pain.",
            value: false,
          },
          {
            text: "Your birth bag should be ready.",
            value: false,
          },
          {
            text: "Sleep on your side and use a pregnancy pillow for extra comfort.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "Avoid lifting heavy items.",
            value: false,
          },
          {
            text: "Choose cosmetics that are safe for pregnant women.",
            value: false,
          },
          {
            text: "Apply a moisturizing body lotion to your abdomen and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Write down important phone numbers you may need when you start birth.",
            value: false,
          },
          {
            text: "If you experience leg cramps outside and in, find a place to sit and then flex your toes towards your body.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "What You Should Have in Your Birth Bag",
        checklists: [
          {
            text: "Toiletries, slippers and socks, make-up materials, toothbrush, moisturizer, lip balm, deodorant, hair bands, etc.",
            value: false,
          },
          {
            text: "Your birth plan",
            value: false,
          },
          {
            text: "Breast pump when you need to express milk",
            value: false,
          },
          {
            text: "At least 3 sets of newborn clothing (avoid complicated clothing; cotton baby suits to cover arms and legs are best)",
            value: false,
          },
          {
            text: "Comfortable and loose clothing for 3 days and a nursing bra. Pack also polyethylene bags (for your dirty laundry)",
            value: false,
          },
          {
            text: "Items to help you relax like comfortable pillows, favorite songs list, snacks etc. ",
            value: false,
          },
          {
            text: "Important documents such as Identity cards, insurance documents, etc. ",
            value: false,
          },
          {
            text: "Phone and phone charger",
            value: false,
          },
          {
            text: "Baby`s homecoming outfit (including socks or booties and blanket)",
            value: false,
          },
          {
            text: "Sanitary pads for the mother",
            value: false,
          },
          {
            text: "Diapers",
            value: false,
          },
          {
            text: "Wet wipes, a gentle baby wash and other baby supplies.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about the procedures you will encounter during a normal or C-section delivery.",
            value: false,
          },
          {
            text: "Search for a birth photographer if you want.",
            value: false,
          },
          {
            text: "If you don`t want artificial pain relief, read about breathing techniques during birth.",
            value: false,
          },
          {
            text: "Learn about signs of birth or preterm birth such as amniotic fluid rupture, menstrual-like cramps, vaginal bleeding, and more.",
            value: false,
          },
          {
            text: "Find out about the vaccinations and tests your newborn should have right after birth.",
            value: false,
          },
          {
            text: "Learn about umbilical cord care for your newborn.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "Make plans for who will look after your baby when you return to work.",
            value: false,
          },
          {
            text: "If you have to sit for long hours at work, try sitting on an exercise ball for short periods of time instead of on your chair.",
            value: false,
          },
          {
            text: "Fill in all the paperwork you need to complete before going on maternity leave.",
            value: false,
          },
          {
            text: "Write down your daily tasks as pregnancy may make you forget.",
            value: false,
          },
          {
            text: "Make sure you drink enough water while at work.",
            value: false,
          },
          {
            text: "Does your office have a breastfeeding/milking room? If not, talk to your manager about organizing one.",
            value: false,
          },
        ],
      },
      {
        tag: 9,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You have a fever greater than 38°C",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You have severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "There is stomach ache",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "There is a sharp decrease in fetal movement",
            value: false,
          },
          {
            text: "You experience strong, painful or regular contractions.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 37,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may experience leg cramps, especially at night.",
            value: false,
          },
          {
            text: "You may have intense and vivid dreams.",
            value: false,
          },
          {
            text: "Your vaginal discharge will increase (beware of bloody show or bloody discharge)",
            value: false,
          },
          {
            text: "Your baby will not kick as much as before, but you will still feel the movements.",
            value: false,
          },
          {
            text: "You may suffer from heartburn and indigestion.",
            value: false,
          },
          {
            text: "Cracks may increase.",
            value: false,
          },
          {
            text: "You may feel forgetful.",
            value: false,
          },
          {
            text: "You may notice that your nipples are now enlarging as you prepare to breastfeed.",
            value: false,
          },
          {
            text: "You may experience pelvic pain.",
            value: false,
          },
          {
            text: "You may have varicose veins.",
            value: false,
          },
          {
            text: "You may experience nausea.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Drink at least 10-12 glasses of water every day.",
            value: false,
          },
          {
            text: "Avoid drinking carbonated beverages.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Eat protein and carbohydrate-rich snacks to give you energy and fight fatigue.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Do pelvic exercises to relieve pain.",
            value: false,
          },
          {
            text: "Practice Kegel exercises to strengthen your pelvic muscles for childbirth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Have a Group B streptococcus screening test (between 35th and 37th weeks)",
            value: false,
          },
          {
            text: "How about an ultrasound to check your baby`s development, position and record the fetal heartbeat!",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Watch out for signs of labor such as bloody vaginal discharge (bloody show).",
            value: false,
          },
          {
            text: "Consult your doctor if you feel unusually sad, anxious or depressed.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the possibility of a vaginal delivery if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Try perineal massage to minimize tearing during delivery.",
            value: false,
          },
          {
            text: "Register early with the maternity hospital of your choice so your check-in experience will be easier later.",
            value: false,
          },
          {
            text: "Make sure your baby`s room is finished.",
            value: false,
          },
          {
            text: "Write down important phone numbers you may need when you start birth.",
            value: false,
          },
          {
            text: "Make sure you can install the car seat correctly",
            value: false,
          },
          {
            text: "Your birth bag should be ready.",
            value: false,
          },
          {
            text: "Sleep on your side and use a pregnancy pillow for extra comfort.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "If you have a birth photographer, make an appointment.",
            value: false,
          },
          {
            text: "Choose cosmetics that are safe for pregnant women.",
            value: false,
          },
          {
            text: "Apply a moisturizing body lotion to your abdomen and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your child by singing songs or even talking to your baby.",
            value: false,
          },
          {
            text: "If you experience leg cramps outside, find a place to sit and then flex your toes towards your body.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about the procedures you will encounter during a normal or cesarean delivery.",
            value: false,
          },
          {
            text: "If you don`t want artificial pain relief, read about breathing techniques during birth.",
            value: false,
          },
          {
            text: "Learn about signs of birth or preterm birth such as rupture of amniotic fluid, menstrual-like cramps, vaginal bleeding, and other.",
            value: false,
          },
          {
            text: "Learn about perineal massage.",
            value: false,
          },
          {
            text: "Learn about umbilical cord care for your newborn.",
            value: false,
          },
          {
            text: "Learn how to bathe your newborn and change diapers.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "If You are a Working Mother",
        checklists: [
          {
            text: "It`s almost time to take leave - you can even start your leave this week or next.",
            value: false,
          },
          {
            text: "If you have to sit for long hours at work, try sitting on an exercise ball for short periods of time instead of on your chair.",
            value: false,
          },
          {
            text: "Delegate tasks to a colleague who will take care while you are on leave.",
            value: false,
          },
        ],
      },
      {
        tag: 8,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You observe an unusual fluid leaking from your vagina",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You have pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "You feel strong, painful or regular contractions",
            value: false,
          },
          {
            text: "You feel a significant decrease in fetal movements",
            value: false,
          },
          {
            text: "You have a fever higher than 38°C",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 38,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may now have more vaginal discharge and may even pass the mucus plug opening process.",
            value: false,
          },
          {
            text: "Your abdomen is large and low and you may experience swelling in your ankles and even your fingers.",
            value: false,
          },
          {
            text: "Your breasts will begin to drip yellowish liquid colostrum, which indicates the start of milk production.",
            value: false,
          },
          {
            text: "Your legs and pelvic area will ache as your baby descends under your pelvis in preparation for birth.",
            value: false,
          },
          {
            text: "Some women experience diarrhea during these times.",
            value: false,
          },
          {
            text: "You may be feeling more Braxton Hicks contractions.",
            value: false,
          },
          {
            text: "Your stomach itches from all this stretching.",
            value: false,
          },
          {
            text: "You will need to go to the bathroom frequently.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Continue to consume healthy foods.",
            value: false,
          },
          {
            text: "Drink at least 10-12 glasses of water every day.",
            value: false,
          },
          {
            text: "Avoid drinking carbonated beverages.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Eat protein and carbohydrate-rich snacks to give you energy and combat fatigue.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Do pelvic exercises to relieve discomfort.",
            value: false,
          },
          {
            text: "Practice Kegel exercises to strengthen your pelvic muscles for childbirth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "How about an ultrasound to check your baby`s development, position and record the fetal heartbeat!",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Pay attention to signs of birth such as bloody discharge from your vagina.",
            value: false,
          },
          {
            text: "Consult your doctor if you feel unusually sad, anxious or depressed.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is any risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "If your breasts start to drip colostrum, place nursing pads in your bra to protect your clothes.",
            value: false,
          },
          {
            text: "Double-check your birth and newborn lists.",
            value: false,
          },
          {
            text: "Buy a breast milk pump if you plan to express frequently.",
            value: false,
          },
          {
            text: "Don`t forget to buy breast pads and nursing bras.",
            value: false,
          },
          {
            text: "Write down any important phone numbers you may need when you start labor.",
            value: false,
          },
          {
            text: "Make sure your baby seat is fitted correctly.",
            value: false,
          },
          {
            text: "Get some of your favorite meals cooked, portioned and frozen.",
            value: false,
          },
          {
            text: "Your birth bag should be ready.",
            value: false,
          },
          {
            text: "Sleep on your side and use a pregnancy pillow for extra comfort.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly.",
            value: false,
          },
          {
            text: "Carry a healthy snack and a small bottle of water with you when you go out.",
            value: false,
          },
          {
            text: "If you have a birth photographer, make an appointment.",
            value: false,
          },
          {
            text: "Choose cosmetics that are safe for pregnant women.",
            value: false,
          },
          {
            text: "Apply a moisturizing body lotion to your abdomen and other areas to prevent stretch marks.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your baby by singing songs or even talking to your baby.",
            value: false,
          },
          {
            text: "If you experience leg cramps outside, find a place to sit and then flex your toes towards your body.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn about the procedures you will encounter during a normal or cesarean delivery.",
            value: false,
          },
          {
            text: "Research on Birth Induction (artificial pain).",
            value: false,
          },
          {
            text: "If you don`t want artificial pain relief, read about breathing techniques during labor.",
            value: false,
          },
          {
            text: "Learn about baby care and parenting.",
            value: false,
          },
          {
            text: "Look for contractions that last at least 45 seconds and appear for up to 5 minutes.",
            value: false,
          },
          {
            text: "If you want to give birth with surgery, learn how to treat cesarean scars.",
            value: false,
          },
          {
            text: "Know the risks for delayed delivery.",
            value: false,
          },
          {
            text: "Know natural ways to speed up labor.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You observe an unusual fluid leaking from your vagina",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You feel pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "You feel strong contractions",
            value: false,
          },
          {
            text: "You feel a significant decrease in fetal movements",
            value: false,
          },
          {
            text: "You have a fever higher than 38 °C",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 39,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may be feeling more Braxton Hicks contractions.",
            value: false,
          },
          {
            text: "You may now have more vaginal discharge and bloody show may have occurred.",
            value: false,
          },
          {
            text: "You always have the urge to clean your place (nesting). But don`t push yourself too hard!",
            value: false,
          },
          {
            text: "Your water may leak - your amniotic sac ruptures and your fluid squirts out.",
            value: false,
          },
          {
            text: "You may feel increased pressure on your pelvis, bladder, and hips and experience pelvic and/or back pain.",
            value: false,
          },
          {
            text: "Some women experience diarrhea during these times.",
            value: false,
          },
          {
            text: "You may experience severe heartburn.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Drink at least 10-12 glasses of water every day",
            value: false,
          },
          {
            text: "Avoid drinking carbonated beverages.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Eat protein and carbohydrate-rich snacks to give you energy and combat fatigue.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Try to go for at least a short walk every day, no matter how hard it is to move.",
            value: false,
          },
          {
            text: "Practice Kegel exercises that will strengthen your pelvic muscles for childbirth.",
            value: false,
          },
          {
            text: "Go up and down stairs carefully as this can help induce labor.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "How about an ultrasound to check your baby`s development, position and record the fetal heartbeat!",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Pay attention to signs of labor such as bloody discharge from your vagina.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position.",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask your doctor about inducing/triggering labor.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Make sure your maternity bag is ready.",
            value: false,
          },
          {
            text: "Talk to your partner about how you want him to support you during labor.",
            value: false,
          },
          {
            text: "Write down important phone numbers you may need when you start labor.",
            value: false,
          },
          {
            text: "Make sure your infant car seat is fitted correctly.",
            value: false,
          },
          {
            text: "Having sex can help induce labor.",
            value: false,
          },
          {
            text: "Make sure the nursery is ready for the baby`s arrival.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "Learn the pros and cons of birthing procedures such as vacuum and forceps.",
            value: false,
          },
          {
            text: "Learn about the importance of colostrum.",
            value: false,
          },
          {
            text: "Search the importance of skin-to-skin contact after birth.",
            value: false,
          },
          {
            text: "Learn how to breathe during labor.",
            value: false,
          },
          {
            text: "Learn about newborn care.",
            value: false,
          },
          {
            text: "Learn about signs of labor or preterm labor such as amniotic fluid rupture, menstrual-like cramps.",
            value: false,
          },
          {
            text: "Learn more about caring for cesarean scars in case of cesarean delivery.",
            value: false,
          },
          {
            text: "Learn natural ways to speed up labor.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You observe an unusual fluid leaking from your vagina",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You feel pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "You feel strong contractions",
            value: false,
          },
          {
            text: "You have contractions that last at least 45 seconds and appear for up to 5 minutes",
            value: false,
          },
          {
            text: "You feel a significant decrease in fetal movements",
            value: false,
          },
          {
            text: "You have a fever higher than 38 °C",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 40,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You will feel pressure and pain in your pelvic area.",
            value: false,
          },
          {
            text: "You may feel very tired and it may be difficult to sleep.",
            value: false,
          },
          {
            text: "You may be feeling more Braxton Hicks contractions.",
            value: false,
          },
          {
            text: "Your water may leak - your amniotic sac ruptures and your fluid squirts out.",
            value: false,
          },
          {
            text: "Some women experience diarrhea during these times.",
            value: false,
          },
          {
            text: "You may experience leg cramps.",
            value: false,
          },
          {
            text: "You always have the urge to clean your place (nesting).",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Drink at least 10-12 glasses of water every day.",
            value: false,
          },
          {
            text: "Avoid drinking carbonated beverages.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Eat protein and carbohydrate-rich snacks to give you energy and combat fatigue.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Practice Kegel exercises to strengthen your pelvic muscles for childbirth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Have a pelvic exam to check your baby`s position and see if you`re starting to open up.",
            value: false,
          },
          {
            text: "Blood pressure control",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check the fetal heart rate.",
            value: false,
          },
          {
            text: "Pay attention to signs of labor such as bloody discharge from your vagina.",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal delivery if you are severely myopic.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position (your baby`s head should be down by now).",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask about inducing birth.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Sleep and rest as much as possible - you will need energy.",
            value: false,
          },
          {
            text: "Call your doctor right away if you have signs of labor.",
            value: false,
          },
          {
            text: "Make sure your maternity bag is ready.",
            value: false,
          },
          {
            text: "Talk to your husband about how you want him to support you during labor.",
            value: false,
          },
          {
            text: "Learn how to reduce pain during labor.",
            value: false,
          },
          {
            text: "Write down important phone numbers you may need when you start labor.",
            value: false,
          },
          {
            text: "Having sex can induce labor.",
            value: false,
          },
          {
            text: "Sleep on your side and use a pregnancy pillow for extra comfort.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly.",
            value: false,
          },
          {
            text: "Make sure the nursery is ready for the baby`s arrival.",
            value: false,
          },
          {
            text: "Go to the hospital when the contractions last 45 to 60 seconds and are three to five minutes apart.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "If you want to give birth naturally, learn how to properly manage your breathing during labor.",
            value: false,
          },
          {
            text: "Learn how to hold your baby to your breasts.",
            value: false,
          },
          {
            text: "Learn about baby care and parenting.",
            value: false,
          },
          {
            text: "Learn how to give birth.",
            value: false,
          },
          {
            text: "Read how your husband can support you after giving birth.",
            value: false,
          },
          {
            text: "Know the signs of rupture of the water bladder.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if...",
        checklists: [
          {
            text: "You observe an unusual fluid leaking from your vagina",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You feel pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "You feel strong contractions",
            value: false,
          },
          {
            text: "You feel a significant decrease in fetal movements",
            value: false,
          },
          {
            text: "You have a fever higher than 38 °C",
            value: false,
          },
          {
            text: "You experience contractions that last at least 45 seconds and are three to five minutes apart.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 41,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may feel a lot of pain and pressure in your pelvic area.",
            value: false,
          },
          {
            text: "You may see bloody mucus coming out of your vagina; this is a sign that your mucus plug has come out.",
            value: false,
          },
          {
            text: "Your water may leak - your amniotic sac ruptures and your fluid squirts out.",
            value: false,
          },
          {
            text: "You may begin to experience contractions - real contractions get stronger and more frequent over time.",
            value: false,
          },
          {
            text: "Some women experience diarrhea during these times.",
            value: false,
          },
          {
            text: "You may have hemorrhoids.",
            value: false,
          },
          {
            text: "You may experience frequent urination.",
            value: false,
          },
          {
            text: "You always have the urge to clean your place (nesting).",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Avoid drinking carbonated beverages.",
            value: false,
          },
          {
            text: "Eat a balanced diet with more vegetables, fruits and other healthy foods.",
            value: false,
          },
          {
            text: "Avoid too much salt, sugar, MSG and preserved foods.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Take your prenatal vitamins daily.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Eat protein and carbohydrate-rich snacks to give you energy and combat fatigue.",
            value: false,
          },
          {
            text: "Practice Kegel exercises to strengthen your pelvic muscles for childbirth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Check your blood pressure.",
            value: false,
          },
          {
            text: "Have a pelvic exam to check your baby`s position and see if opening has begun.",
            value: false,
          },
          {
            text: "Check the fetal heart rate.",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal birth if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position (your baby`s head should be down by now).",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask to induce labor.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Sleep and rest as much as possible - you will need energy.",
            value: false,
          },
          {
            text: "Try to relax by taking a warm bath or swimming.",
            value: false,
          },
          {
            text: "Discuss your chosen delivery method with your doctor.",
            value: false,
          },
          {
            text: "Call your doctor right away if you have signs of labor.",
            value: false,
          },
          {
            text: "Make sure your maternity bag is ready.",
            value: false,
          },
          {
            text: "Talk to your husband about how you want him to support you during labor.",
            value: false,
          },
          {
            text: "Learn how to reduce pain during labor.",
            value: false,
          },
          {
            text: "Write down important phone numbers you may need when you start labor.",
            value: false,
          },
          {
            text: "Having sex can induce labor.",
            value: false,
          },
          {
            text: "Sleep on your side and use a pregnancy pillow for extra comfort.",
            value: false,
          },
          {
            text: "Follow your baby`s movements.",
            value: false,
          },
          {
            text: "Choose a more active time of the day, such as after a meal. If you don`t feel at least 10 baby movements within two hours, contact your doctor.",
            value: false,
          },
          {
            text: "Take a weekly picture of your belly.",
            value: false,
          },
          {
            text: "Make sure the nursery is ready for the baby`s arrival.",
            value: false,
          },
          {
            text: "Go to the hospital when the contractions last 45 to 60 seconds and are three to five minutes apart.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "If you want to give birth naturally, learn how to properly manage your breathing during labor.",
            value: false,
          },
          {
            text: "Learn how to hold your baby to your breasts.",
            value: false,
          },
          {
            text: "Learn about baby care and parenting.",
            value: false,
          },
          {
            text: "Learn how to give birth.",
            value: false,
          },
          {
            text: "Read how your husband can support you after giving birth.",
            value: false,
          },
          {
            text: "Know the signs of rupture of the water bladder.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You observe an unusual fluid leaking from your vagina",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You feel pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "You feel strong contractions",
            value: false,
          },
          {
            text: "You feel a significant decrease in fetal movements",
            value: false,
          },
          {
            text: "You have a fever higher than 38 °C",
            value: false,
          },
          {
            text: "You experience contractions that last at least 45 seconds and are three to five minutes apart.",
            value: false,
          },
        ],
      },
    ],
  },
  {
    id: 42,
    values: [
      {
        tag: 1,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Symptoms",
        checklists: [
          {
            text: "You may experience regular contractions - true labor contractions will be repeated, at shorter intervals and of higher intensity.",
            value: false,
          },
          {
            text: "Sometimes you may experience a thick mucus discharge mixed with blood - this is a sign that the cervix is preparing for delivery.",
            value: false,
          },
          {
            text: "You may feel a gush of clear, odorless liquid or even a steady drip. It indicates that your amniotic sac has probably burst.",
            value: false,
          },
          {
            text: "You may experience leg cramps, frequent urination, pelvic and back pain, nesting instincts, spotting, hemorrhoids and diarrhea.",
            value: false,
          },
        ],
      },
      {
        tag: 2,
        backgroundColor: "#F9FFFB",
        head: "Nutrition and Health",
        checklists: [
          {
            text: "Drink at least 10-12 glasses of water every day.",
            value: false,
          },
          {
            text: "Eat more vegetables, fruits and other healthy foods as you will need a lot of stamina for childbirth.",
            value: false,
          },
          {
            text: "Avoid foods with added salt, MSG and preservatives.",
            value: false,
          },
          {
            text: "Avoid consuming raw or half-cooked foods during pregnancy.",
            value: false,
          },
          {
            text: "Consume pregnancy vitamins recommended by your doctor.",
            value: false,
          },
          {
            text: "Eat protein and carbohydrate-rich snacks to give you energy and combat fatigue.",
            value: false,
          },
          {
            text: "Limit your caffeine intake.",
            value: false,
          },
          {
            text: "Do pelvic exercises to relieve pain.",
            value: false,
          },
          {
            text: "Practice Kegel exercises to strengthen your pelvic muscles for childbirth.",
            value: false,
          },
        ],
      },
      {
        tag: 3,
        backgroundColor: "#F9FFFB",
        head: "Health Controls",
        checklists: [
          {
            text: "Monitor your weight gain (this depends on your pre-pregnancy weight and height. In general, the average total weight gain during pregnancy is between 9 and 14 kg)",
            value: false,
          },
          {
            text: "Check your blood pressure and blood sugar level.",
            value: false,
          },
          {
            text: "Have a pelvic exam to check your baby`s position and see if you`re starting to open up.",
            value: false,
          },
          {
            text: "Check the fetal heart rate.",
            value: false,
          },
          {
            text: "Urine test - to check for protein, glucose (sugar), white blood cells, blood and bacteria",
            value: false,
          },
          {
            text: "Check if your hands or feet are swollen.",
            value: false,
          },
          {
            text: "Doctor can recommend ultrasound, NST and biophysical profile to assess your fetal baby`s heart rate, response and well-being.",
            value: false,
          },
        ],
      },
      {
        tag: 4,
        backgroundColor: "#F9FFFB",
        head: "Questions to Ask Your Doctor",
        checklists: [
          {
            text: "Ask if there is a risk of preeclampsia and gestational diabetes.",
            value: false,
          },
          {
            text: "Ask if your umbilical cord is healthy and normal.",
            value: false,
          },
          {
            text: "Ask if your placenta is in the correct position.",
            value: false,
          },
          {
            text: "Ask about the risks of having a vaginal birth if you have severe myopia.",
            value: false,
          },
          {
            text: "Ask your doctor about the baby`s position (your baby`s head should be down by now).",
            value: false,
          },
          {
            text: "Ask about your amniotic fluid levels.",
            value: false,
          },
          {
            text: "Ask to induce labor.",
            value: false,
          },
        ],
      },
      {
        tag: 5,
        backgroundColor: "#F9FFFB",
        head: "Reminders",
        checklists: [
          {
            text: "Continue to monitor for signs of labor that may be at any time.",
            value: false,
          },
          {
            text: "If the baby`s condition is poor or high risk, your doctor may recommend induction (artificial labor) or cesarean section.",
            value: false,
          },
          {
            text: "Take time to rest your body as much as possible in preparation for birth.",
            value: false,
          },
          {
            text: "Write down important phone numbers you may need when you start labor.",
            value: false,
          },
          {
            text: "Learn to recognize the signs of rupture of the amniotic sac.",
            value: false,
          },
          {
            text: "Call your doctor right away if you have signs of labor.",
            value: false,
          },
          {
            text: "Make sure your maternity bag contains everything you need and you`re ready to go.",
            value: false,
          },
          {
            text: "Inform your husband about what is needed to prepare for your birth.",
            value: false,
          },
          {
            text: "Do exercises to reduce pain during labor.",
            value: false,
          },
          {
            text: "Calm yourself by distracting your mind by doing things you love.",
            value: false,
          },
          {
            text: "Take the last pregnant selfie you can!",
            value: false,
          },
          {
            text: "Make sure the nursery is ready for the baby`s arrival.",
            value: false,
          },
          {
            text: "Ask your husband to talk to your baby.",
            value: false,
          },
          {
            text: "Sex at this stage can be very uncomfortable and it can trigger labor.",
            value: false,
          },
          {
            text: "Spend at least 10-15 minutes a day for stimulating your little one by singing songs or even talking to your baby.",
            value: false,
          },
          {
            text: "Check for fetal movements twice a day - morning and evening.",
            value: false,
          },
          {
            text: "Choose a time when the baby is more active, such as after a meal. Call your doctor if you don`t feel at least 10 baby movements within two hours.",
            value: false,
          },
        ],
      },
      {
        tag: 6,
        backgroundColor: "#F9FFFB",
        head: "Pregnancy Search",
        checklists: [
          {
            text: "It is important to know how to properly manage your breathing during labor.",
            value: false,
          },
          {
            text: "Learn about baby care and parenting.",
            value: false,
          },
          {
            text: "Know the signs of labor such as rupture of amniotic fluid, menstrual bleeding (such as cramps, vaginal bleeding and others).",
            value: false,
          },
          {
            text: "Learn about late labor and labor induction.",
            value: false,
          },
          {
            text: "Learn more about caring for cesarean scars in case of cesarean delivery.",
            value: false,
          },
          {
            text: "Know natural ways to speed up labor.",
            value: false,
          },
        ],
      },
      {
        tag: 7,
        backgroundColor: "#F9FFFB",
        head: "Call Your Doctor if…",
        checklists: [
          {
            text: "You observe an unusual fluid leaking from your vagina",
            value: false,
          },
          {
            text: "You are experiencing excessive or smelly vaginal discharge",
            value: false,
          },
          {
            text: "You experience severe vomiting and ongoing nausea",
            value: false,
          },
          {
            text: "You feel severe or persistent abdominal pain",
            value: false,
          },
          {
            text: "You feel pain when urinating",
            value: false,
          },
          {
            text: "Your hands and feet are severely swollen",
            value: false,
          },
          {
            text: "You are experiencing spotting or vaginal bleeding",
            value: false,
          },
          {
            text: "You have a severe headache",
            value: false,
          },
          {
            text: "You experience visual impairment",
            value: false,
          },
          {
            text: "Your face suddenly looks swollen; this could be a sign of preeclampsia",
            value: false,
          },
          {
            text: "You feel strong contractions",
            value: false,
          },
          {
            text: "You feel a significant decrease in fetal movements",
            value: false,
          },
          {
            text: "You have a fever higher than 38 °C",
            value: false,
          },
          {
            text: "You experience contractions that last at least 45 seconds and are three to five minutes apart.",
            value: false,
          },
        ],
      },
    ],
  },
];

export { default_pregnancy_milestone_value_en };
